<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>

      <div class="page-wrapper">
        <div class="content container-fluid">
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">
                  {{ flow ? flow.name || "Detail Auto Follow Up" : "Detail Auto Follow Up" }}
                  <span
                    class="afu-beta-inline"
                    title="Fitur masih dalam tahap Beta"
                  >BETA</span>
                </h3>
                <p class="text-muted mb-2">
                  {{
                    flow && flow.description
                      ? flow.description
                      : "Pantau status kontak dan riwayat pengiriman alur ini."
                  }}
                </p>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/auto-follow-up">Auto Follow Up</router-link>
                  </li>
                  <li class="breadcrumb-item active">Detail</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto afu-detail-header-actions">
                <span
                  v-if="flow"
                  class="afu-status-badge mr-2"
                  :class="'afu-status-' + flowTone(flow.status)"
                >
                  {{ flowStatusLabel(flow.status) }}
                </span>
                <button
                  type="button"
                  class="btn btn-outline-secondary mr-2"
                  :disabled="pageLoading || refreshing || !!actionLoading"
                  @click="refreshAll"
                >
                  <i class="fa fa-refresh" :class="{ 'fa-spin': refreshing }"></i>
                  Muat Ulang
                </button>
                <button type="button" class="btn btn-outline-secondary" @click="goToList">
                  <i class="fa fa-arrow-left"></i>
                  Kembali
                </button>
              </div>
            </div>
          </div>

          <div v-if="pageLoading" class="card afu-detail-card">
            <div class="card-body text-center py-5">
              <i class="fa fa-spinner fa-spin fa-2x text-muted"></i>
              <p class="text-muted mt-3 mb-0">Memuat detail alur...</p>
            </div>
          </div>

          <div v-else-if="loadError" class="card afu-detail-card">
            <div class="card-body py-5 text-center">
              <i class="fa fa-exclamation-triangle fa-2x text-danger"></i>
              <h5 class="mt-3">Detail alur belum dapat dimuat</h5>
              <p class="text-muted">{{ loadError }}</p>
              <button type="button" class="btn btn-outline-primary mr-2" @click="initialize">
                Coba Lagi
              </button>
              <button type="button" class="btn btn-outline-secondary" @click="goToList">
                Kembali ke Daftar
              </button>
            </div>
          </div>

          <template v-else-if="flow">
            <div v-if="autoSwitchEnabled" class="alert alert-warning">
              <i class="fa fa-exchange"></i>
              <strong>Pengalihan nomor pengirim aktif.</strong>
              Waajo dapat mengirim pesan dengan nomor lain yang sedang terhubung.
              Nomor yang Anda pilih tetap menjadi acuan kuota Auto Follow Up,
              tetapi nomor pengirim sebenarnya bisa berbeda.
            </div>

            <div v-if="actionError" class="alert alert-danger">
              <i class="fa fa-exclamation-circle"></i>
              {{ actionError }}
            </div>

            <div class="card afu-detail-card afu-action-bar">
              <div class="afu-action-bar-left">
                <div class="afu-action-title">Tindakan Alur</div>
                <div class="text-muted small">
                  Tindakan yang memengaruhi kontak akan dikonfirmasi lebih dulu.
                </div>
              </div>
              <div class="afu-action-buttons">
                <button
                  v-if="canEdit"
                  type="button"
                  class="btn btn-outline-secondary"
                  :disabled="!!actionLoading"
                  @click="goEdit"
                >
                  <i class="fa fa-pencil"></i>
                  {{ flow.status === "draft" ? "Ubah Alur" : "Ubah Pengaturan" }}
                </button>
                <button
                  v-if="canSaveTemplate"
                  type="button"
                  class="btn btn-outline-secondary"
                  :disabled="!!actionLoading || templateSaving"
                  @click="openTemplateModal"
                >
                  <i class="fa fa-copy"></i>
                  Simpan sebagai Template
                </button>
                <button
                  v-if="canActivate"
                  type="button"
                  class="btn afu-primary-btn"
                  :disabled="!!actionLoading"
                  @click="flowAction('activate')"
                >
                  <i
                    :class="
                      actionLoading === 'activate'
                        ? 'fa fa-spinner fa-spin'
                        : 'fa fa-play'
                    "
                  ></i>
                  Aktifkan
                </button>
                <button
                  v-if="canPause"
                  type="button"
                  class="btn btn-outline-warning"
                  :disabled="!!actionLoading"
                  @click="flowAction('pause')"
                >
                  <i
                    :class="
                      actionLoading === 'pause'
                        ? 'fa fa-spinner fa-spin'
                        : 'fa fa-pause'
                    "
                  ></i>
                  Jeda
                </button>
                <button
                  v-if="canResume"
                  type="button"
                  class="btn afu-primary-btn"
                  :disabled="!!actionLoading"
                  @click="flowAction('resume')"
                >
                  <i
                    :class="
                      actionLoading === 'resume'
                        ? 'fa fa-spinner fa-spin'
                        : 'fa fa-play'
                    "
                  ></i>
                  Lanjutkan
                </button>
                <button
                  v-if="canCancel"
                  type="button"
                  class="btn btn-outline-danger"
                  :disabled="!!actionLoading"
                  @click="flowAction('cancel')"
                >
                  <i
                    :class="
                      actionLoading === 'cancel'
                        ? 'fa fa-spinner fa-spin'
                        : 'fa fa-ban'
                    "
                  ></i>
                  Batalkan
                </button>
                <button
                  v-if="canDelete"
                  type="button"
                  class="btn btn-outline-danger"
                  :disabled="!!actionLoading"
                  @click="flowAction('delete')"
                >
                  <i
                    :class="
                      actionLoading === 'delete'
                        ? 'fa fa-spinner fa-spin'
                        : 'fa fa-trash'
                    "
                  ></i>
                  Hapus
                </button>
              </div>
            </div>

            <div class="card afu-detail-card">
              <div class="card-body">
                <div class="row">
                  <div class="col-lg-4 mb-3 mb-lg-0">
                    <div class="afu-detail-label">Nomor WhatsApp pengirim</div>
                    <div class="afu-detail-value">
                      {{ licenseLabel }}
                    </div>
                    <small v-if="license" class="text-muted">
                      {{ license.license_name || license.license_phone_number || "Nomor WhatsApp" }}
                      <span v-if="licenseStatusLabel(license)">
                        · {{ licenseStatusLabel(license) }}
                      </span>
                    </small>
                    <div v-else-if="licenseError" class="afu-inline-warning mt-1">
                      {{ licenseError }}
                    </div>
                    <div v-if="autoSwitchEnabled" class="afu-small-note mt-2">
                      Nomor pengirim bisa berbeda jika pengalihan nomor aktif.
                    </div>
                  </div>

                  <div class="col-lg-4 mb-3 mb-lg-0">
                    <div class="afu-detail-label">Jadwal pengiriman berikutnya</div>
                    <div class="afu-detail-value">
                      <template v-if="statsLoading">
                        <i class="fa fa-spinner fa-spin"></i>
                      </template>
                      <template v-else>{{ nextScheduleText }}</template>
                    </div>
                    <span
                      v-if="nextScheduleBadge"
                      class="afu-schedule-badge"
                      :class="'afu-schedule-tone-' + scheduleTone(scheduleInfo.state)"
                    >
                      {{ nextScheduleBadge }}
                    </span>
                    <div v-if="nextScheduleReason" class="afu-small-note mt-1">
                      {{ nextScheduleReason }}
                    </div>
                    <button
                      v-if="canRetrySchedule"
                      type="button"
                      class="btn btn-sm btn-outline-primary mt-2"
                      :disabled="!!actionLoading"
                      @click="retryScheduling"
                    >
                      <i
                        :class="
                          actionLoading === 'retry-scheduling'
                            ? 'fa fa-spinner fa-spin'
                            : 'fa fa-refresh'
                        "
                      ></i>
                      Coba Jadwalkan Ulang
                    </button>
                    <div v-if="retrySummaryMessage" class="afu-small-note mt-1">
                      {{ retrySummaryMessage }}
                    </div>
                    <div class="afu-detail-label mt-3">Aktivitas terakhir</div>
                    <div>{{ lastActivityText }}</div>
                  </div>

                  <div class="col-lg-4">
                    <div class="afu-detail-label">Pengaturan pengiriman</div>
                    <div class="afu-config-line">
                      <span>Jam kirim</span>
                      <strong>
                        {{ flow.sending_start_time || "-" }}–{{ flow.sending_end_time || "-" }}
                        <span class="text-muted">({{ flow.timezone || "Asia/Jakarta" }})</span>
                      </strong>
                    </div>
                    <div class="afu-config-line">
                      <span>Kontak per pengiriman</span>
                      <strong>
                        {{ flow.batch_min_contacts || 0 }}–{{ flow.batch_max_contacts || 0 }} kontak
                      </strong>
                    </div>
                    <div class="afu-config-line">
                      <span>Jeda pesan</span>
                      <strong>{{ delayRangeText }}</strong>
                    </div>
                    <div class="afu-config-line">
                      <span>Batas lisensi per hari</span>
                      <strong>
                        {{ quotaInfo ? (quotaInfo.daily_limit || 0) + " pesan" : (flow.daily_contact_limit || 0) + " kontak (legacy)" }}
                      </strong>
                    </div>
                    <div class="afu-config-line">
                      <span>Berhenti saat membalas</span>
                      <strong>
                        {{ Number(flow.stop_on_customer_reply) === 1 ? "Ya" : "Tidak" }}
                      </strong>
                    </div>
                  </div>
                </div>

                <div class="afu-source-row">
                  <span class="afu-detail-label mr-2">Sumber kontak</span>
                  <span
                    v-for="source in sources"
                    :key="source.source_type + ':' + source.source_id"
                    class="afu-source-badge"
                  >
                    {{ sourceTypeLabel(source.source_type) }}:
                    {{ source.source_name || "Sumber kontak" }}
                  </span>
                  <span v-if="!sources.length" class="text-muted">Belum ada sumber kontak.</span>
                </div>
              </div>
            </div>

            <div class="afu-quota-card mb-3">
              <div class="d-flex flex-wrap justify-content-between align-items-start">
                <div class="pr-3">
                  <div class="afu-detail-label">Kuota lisensi hari ini</div>
                  <div v-if="quotaLoading" class="text-muted">
                    <i class="fa fa-spinner fa-spin"></i> Memuat kuota...
                  </div>
                  <div v-else-if="quotaInfo" class="afu-quota-summary">
                    <span
                      class="afu-quota-badge"
                      :class="quotaInfo.status === 'normal' ? 'afu-quota-normal' : 'afu-quota-reached'"
                    >
                      {{ quotaInfo.status_label || (quotaInfo.status === "normal" ? "Normal" : "Tercapai") }}
                    </span>
                    <strong>{{ quotaInfo.remaining_count || 0 }}</strong>
                    dari {{ quotaInfo.daily_limit || 0 }} kontak tersisa
                    <small class="text-muted d-block mt-1">
                      Terkirim {{ quotaInfo.sent_count || 0 }} kontak ·
                      Reservasi {{ quotaInfo.reserved_count || 0 }} kontak ·
                      Terpakai {{ quotaInfo.used_count || 0 }} kontak ·
                      Gagal {{ quotaInfo.failed_count || 0 }} kontak ·
                      Reset {{ formatScheduleDate(quotaInfo.reset_at, quotaInfo.timezone) }}
                    </small>
                  </div>
                  <div v-else-if="quotaError" class="afu-inline-warning mt-1">
                    {{ quotaError }}
                  </div>
                  <div v-else class="text-muted">Informasi kuota belum tersedia.</div>
                  <div
                    v-if="quotaInfo && quotaInfo.status !== 'normal'"
                    class="afu-inline-warning mt-2"
                  >
                    {{ quotaInfo.reason_message || "Pengiriman belum dapat dijadwalkan karena batas pengiriman harian lisensi ini telah tercapai." }}
                    Kuota akan tersedia kembali pada
                    {{ formatScheduleDate(quotaInfo.reset_at, quotaInfo.timezone) }}.
                  </div>
                </div>
                <div class="afu-quota-actions">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary"
                    :disabled="quotaLoading || !!quotaActionLoading"
                    @click="openQuotaDetail"
                  >
                    <i class="fa fa-info-circle"></i> Lihat detail limit
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary ml-2"
                    :disabled="quotaLoading || !!quotaActionLoading"
                    @click="reconcileQuota"
                  >
                    <i class="fa fa-refresh"></i> Rekonsiliasi reservasi
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-danger ml-2"
                    :disabled="quotaLoading || !!quotaActionLoading"
                    @click="openQuotaReset"
                  >
                    <i class="fa fa-sliders"></i> Reset limit
                  </button>
                </div>
              </div>
            </div>

            <ul class="nav nav-tabs afu-detail-tabs">
              <li class="nav-item">
                <a
                  href="javascript:void(0)"
                  class="nav-link"
                  :class="{ active: activeTab === 'overview' }"
                  @click="activeTab = 'overview'"
                >
                  <i class="fa fa-dashboard"></i>
                  Ringkasan
                </a>
              </li>
              <li class="nav-item">
                <a
                  href="javascript:void(0)"
                  class="nav-link"
                  :class="{ active: activeTab === 'recipients' }"
                  @click="activeTab = 'recipients'"
                >
                  <i class="fa fa-users"></i>
                  Kontak Penerima
                  <span v-if="stats" class="afu-tab-count">
                    {{ formatNumber(stats.total_recipients) }}
                  </span>
                </a>
              </li>
              <li class="nav-item">
                <a
                  href="javascript:void(0)"
                  class="nav-link"
                  :class="{ active: activeTab === 'history' }"
                  @click="activateHistoryTab"
                >
                  <i class="fa fa-history"></i>
                  Riwayat
                  <span v-if="eventsTotal" class="afu-tab-count">
                    {{ formatNumber(eventsTotal) }}
                  </span>
                </a>
              </li>
            </ul>

            <div v-show="activeTab === 'overview'">
              <div class="row">
                <div
                  class="col-xl-3 col-sm-6"
                  v-for="card in statCards"
                  :key="card.key"
                >
                  <div class="card afu-stat-card" :title="card.hint || ''">
                    <div class="card-body">
                      <div class="d-flex align-items-center">
                        <span class="afu-stat-icon" :class="card.tone">
                          <i :class="card.icon"></i>
                        </span>
                        <div class="ml-3">
                          <div class="afu-stat-label">{{ card.label }}</div>
                          <div class="afu-stat-value">
                            <i
                              v-if="statsLoading"
                              class="fa fa-spinner fa-spin text-muted"
                            ></i>
                            <template v-else>{{ metricValue(card.key) }}</template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="statsError" class="alert alert-warning d-flex align-items-center justify-content-between flex-wrap">
                <span>
                  <i class="fa fa-exclamation-triangle"></i>
                  Ringkasan alur belum dapat dimuat.
                </span>
                <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="statsLoading" @click="loadStats">
                  Coba Lagi
                </button>
              </div>

              <div class="row">
                <div class="col-lg-6">
                  <div class="card afu-detail-card">
                    <div class="card-header afu-card-header">
                      <h5>Status Kontak</h5>
                    </div>
                    <div class="card-body afu-metric-list">
                      <div
                        v-for="metric in recipientMetrics"
                        :key="metric.key"
                        class="afu-metric-row"
                        :title="metric.hint || ''"
                      >
                        <span>{{ metric.label }}</span>
                        <strong>{{ metricValue(metric.key) }}</strong>
                      </div>
                      <p class="text-muted small mb-0 mt-2">
                        Angka “Dihentikan atau gagal” mencakup kontak yang
                        dihentikan dan gagal. Angka “Gagal” adalah bagian dari
                        jumlah tersebut.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="card afu-detail-card">
                    <div class="card-header afu-card-header">
                      <h5>Status Pengiriman</h5>
                    </div>
                    <div class="card-body afu-metric-list">
                      <div
                        v-for="metric in messageMetrics"
                        :key="metric.key"
                        class="afu-metric-row"
                        :title="metric.hint || ''"
                      >
                        <span>{{ metric.label }}</span>
                        <strong>{{ metricValue(metric.key) }}</strong>
                      </div>
                      <p class="text-muted small mb-0 mt-2">
                        “Berhasil dikirim” berarti Waajo sudah mengirim pesan,
                        tetapi belum tentu pesan sudah dibaca penerima.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row afu-steps-layout">
                <div class="col-xl-7 afu-steps-editor-col">
                  <div class="card afu-detail-card">
                    <div class="card-header afu-card-header">
                      <div>
                        <h5>Rangkaian Pesan</h5>
                        <small class="text-muted">
                          Pesan pertama dihitung dari waktu kontak masuk. Pesan
                          berikutnya dihitung dari pesan sebelumnya yang berhasil
                          dikirim.
                        </small>
                      </div>
                      <span class="afu-section-count">{{ steps.length }} pesan</span>
                    </div>
                    <div class="card-body">
                      <div v-if="!steps.length" class="afu-empty-inline">
                        Belum ada pesan.
                      </div>
                      <div
                        v-for="(step, index) in steps"
                        :key="step.id || step.step_order"
                        class="afu-step-card"
                        :class="{ 'is-preview-active': previewStepIndex === index }"
                      >
                        <div class="afu-step-header">
                          <div>
                            <span class="afu-step-number">Pesan {{ step.step_order }}</span>
                            <strong class="ml-2">
                              {{ step.name || "Pesan " + step.step_order }}
                            </strong>
                          </div>
                          <div class="afu-step-header-right">
                            <span class="badge badge-light">
                              {{ messageTypeLabel(step.message_type) }}
                            </span>
                            <button
                              type="button"
                              class="btn btn-sm btn-outline-secondary afu-preview-step-btn"
                              :class="{ 'is-active': previewStepIndex === index }"
                              title="Tampilkan pesan ini di preview WhatsApp"
                              @click="selectPreviewStep(index)"
                            >
                              <i class="fa fa-eye"></i>
                              Preview
                            </button>
                          </div>
                        </div>
                        <div class="text-muted small mb-2">
                          {{ stepDelayText(index) }} ·
                          {{ step.delay_value }} {{ delayUnitLabel(step.delay_unit) }}
                        </div>
                        <div v-if="step.message_content" class="afu-step-content">
                          {{ step.message_content }}
                        </div>
                        <div v-else class="text-muted small">
                          {{ step.message_type === "text" ? "-" : "Tanpa teks pendamping." }}
                        </div>
                        <a
                          v-if="step.message_media"
                          :href="step.message_media"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="d-inline-block mt-2"
                        >
                          <i class="fa fa-paperclip"></i>
                          Lihat media
                        </a>
                        <div class="afu-step-stats">
                          <span>
                            Terjadwal:
                            <strong>{{ stepStatValue(step, "scheduled") }}</strong>
                          </span>
                          <span>
                            Berhasil dikirim:
                            <strong>{{ stepStatValue(step, "sent") }}</strong>
                          </span>
                          <span>
                            Gagal dikirim:
                            <strong>{{ stepStatValue(step, "failed") }}</strong>
                          </span>
                          <span>
                            Hasil belum pasti:
                            <strong>{{ stepStatValue(step, "uncertain") }}</strong>
                          </span>
                          <span>
                            Tidak jadi dikirim:
                            <strong>{{ stepStatValue(step, "skipped") }}</strong>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-5 afu-steps-preview-col">
                  <afu-whatsapp-preview
                    :steps="steps"
                    :active-index.sync="previewStepIndex"
                  />
                </div>
              </div>

              <div v-if="dailyUsage.length" class="card afu-detail-card">
                <div class="card-header afu-card-header">
                  <h5>Pengiriman per Hari</h5>
                </div>
                <div class="card-body p-0">
                  <div class="table-responsive">
                    <table class="table table-hover mb-0 afu-table">
                      <thead>
                        <tr>
                          <th>Tanggal</th>
                          <th class="text-right">Berhasil dikirim</th>
                          <th class="text-right">Gagal dikirim</th>
                          <th class="text-right">Membalas</th>
                          <th class="text-right">Tidak jadi dikirim</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="day in dailyUsage" :key="day.date">
                          <td>{{ day.date }}</td>
                          <td class="text-right">{{ formatNumber(day.sent) }}</td>
                          <td class="text-right">{{ formatNumber(day.failed) }}</td>
                          <td class="text-right">{{ formatNumber(day.replied) }}</td>
                          <td class="text-right">{{ formatNumber(day.skipped) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div v-show="activeTab === 'recipients'">
              <div class="card afu-detail-card">
                <div class="card-header afu-card-header">
                  <div>
                    <h5>Kontak Penerima</h5>
                    <small class="text-muted">
                      Daftar kontak ditentukan saat alur diaktifkan.
                    </small>
                  </div>
                  <span class="afu-section-count">
                    {{ formatNumber(recipientTotal) }} kontak
                  </span>
                </div>
                <div class="card-body">
                  <div class="alert alert-info afu-api-note">
                    Status pesan terakhir tidak ditampilkan di daftar ini.
                    Gunakan tombol <strong>Riwayat</strong> pada kontak untuk
                    melihat aktivitas pengirimannya.
                  </div>

                  <div class="afu-filter-row">
                    <div class="afu-filter-search">
                      <label class="afu-filter-label">Cari nomor kontak</label>
                      <input
                        v-model="recipientFilters.search"
                        type="text"
                        class="form-control"
                        placeholder="Cari nomor WhatsApp..."
                        :disabled="recipientsLoading"
                        @keyup.enter="applyRecipientFilters"
                      />
                    </div>
                    <div class="afu-filter-status">
                      <label class="afu-filter-label">Status kontak</label>
                      <select
                        v-model="recipientFilters.status"
                        class="form-control"
                        :disabled="recipientsLoading"
                        @change="applyRecipientFilters"
                      >
                        <option
                          v-for="option in recipientStatusOptions"
                          :key="option.value"
                          :value="option.value"
                        >
                          {{ option.label }}
                        </option>
                      </select>
                    </div>
                    <div class="afu-filter-buttons">
                      <button
                        type="button"
                        class="btn afu-primary-btn"
                        :disabled="recipientsLoading"
                        @click="applyRecipientFilters"
                      >
                        <i
                          :class="
                            recipientsLoading
                              ? 'fa fa-spinner fa-spin'
                              : 'fa fa-search'
                          "
                        ></i>
                        Cari
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-secondary"
                        :disabled="recipientsLoading"
                        @click="resetRecipientFilters"
                      >
                        Atur Ulang
                      </button>
                    </div>
                  </div>

                  <div v-if="recipientsError" class="alert alert-danger d-flex align-items-center justify-content-between flex-wrap">
                    <span>
                      <i class="fa fa-exclamation-triangle"></i>
                      {{ recipientsError }}
                    </span>
                    <button type="button" class="btn btn-sm btn-outline-danger" :disabled="recipientsLoading" @click="loadRecipients()">
                      Coba Lagi
                    </button>
                  </div>

                  <div v-if="recipientsLoading && !recipients.length" class="py-4">
                    <Skeleton :count="6" height="52px" gap="10px" />
                  </div>

                  <div
                    v-else-if="!recipientsLoading && !recipients.length && !recipientsError"
                    class="afu-empty-inline py-5"
                  >
                    <i class="fa fa-users fa-2x text-muted"></i>
                    <h6 class="mt-3">
                      {{
                        flow.status === "draft"
                          ? "Kontak penerima belum ditentukan"
                          : "Belum ada kontak penerima"
                      }}
                    </h6>
                    <p class="text-muted mb-0">
                      {{
                        flow.status === "draft"
                          ? "Daftar kontak akan ditentukan saat alur diaktifkan."
                          : "Tidak ada kontak yang sesuai dengan pencarian atau filter."
                      }}
                    </p>
                  </div>

                  <div v-else-if="recipients.length" class="table-responsive">
                    <table class="table table-hover custom-table mb-0 afu-table afu-recipient-table">
                      <thead>
                        <tr>
                          <th>Kontak</th>
                          <th>Status</th>
                          <th>Pesan</th>
                          <th>Jadwal Berikutnya</th>
                          <th>Aktivitas</th>
                          <th class="text-right">Tindakan</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="row in recipients" :key="row.id">
                          <td>
                            <div class="afu-contact-name">
                              {{ row.contact_name || "-" }}
                            </div>
                            <small class="text-muted">
                              {{ row.contact_phone || "-" }}
                            </small>
                          </td>
                          <td>
                            <span
                              class="afu-status-badge"
                              :class="'afu-recipient-' + recipientTone(row.status)"
                            >
                              {{ recipientStatusLabel(row.status) }}
                            </span>
                            <small
                              v-if="row.stop_reason"
                              class="d-block text-muted mt-1"
                              :class="{ 'text-danger': row.status === 'failed' }"
                            >
                              {{ stopReasonLabel(row.stop_reason) }}
                            </small>
                          </td>
                          <td>
                            <div>{{ recipientStepText(row) }}</div>
                            <small class="text-muted">
                              {{ recipientNextStepText(row) }}
                            </small>
                          </td>
                          <td>
                            <div v-if="row.next_scheduled_at">
                              {{ formatScheduleDate(row.next_scheduled_at, scheduleInfo.timezone) }}
                            </div>
                            <span
                              v-if="row.schedule_label || row.schedule_state"
                              class="afu-schedule-badge"
                              :class="'afu-schedule-tone-' + scheduleTone(row.schedule_state)"
                              :title="recipientScheduleTitle(row)"
                            >
                              {{
                                recipientScheduleLabel(row)
                              }}
                            </span>
                            <small
                              v-if="recipientScheduleReason(row)"
                              class="d-block text-muted mt-1"
                            >
                              {{ recipientScheduleReason(row) }}
                            </small>
                          </td>
                          <td>
                            <div>{{ formatDate(row.update_datetime) }}</div>
                            <small class="text-muted">
                              Dikirim: {{ formatDate(row.last_sent_at) }}
                            </small>
                          </td>
                          <td class="text-right afu-actions-cell">
                            <button
                              type="button"
                              class="btn btn-sm btn-outline-secondary mr-1"
                              @click="openRecipientHistory(row)"
                            >
                              <i class="fa fa-history"></i>
                              Riwayat
                            </button>
                            <button
                              v-if="canStopRecipient(row)"
                              type="button"
                              class="btn btn-sm btn-outline-danger"
                              :disabled="recipientActionId === row.id"
                              @click="stopRecipient(row)"
                            >
                              <i
                                :class="
                                  recipientActionId === row.id
                                    ? 'fa fa-spinner fa-spin'
                                    : 'fa fa-stop'
                                "
                              ></i>
                              Hentikan
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div v-if="recipients.length" class="afu-pagination">
                    <div class="afu-pagination-left">
                      <span>Tampilkan</span>
                      <select
                        v-model.number="recipientPerPage"
                        class="select-to-paginasi"
                        :disabled="recipientsLoading"
                        @change="onRecipientPerPageChange"
                      >
                        <option :value="10">10 / halaman</option>
                        <option :value="20">20 / halaman</option>
                        <option :value="50">50 / halaman</option>
                        <option :value="100">100 / halaman</option>
                      </select>
                      <span>dari {{ formatNumber(recipientTotal) }} kontak</span>
                    </div>
                    <div class="afu-pagination-right">
                      <a
                        href="javascript:void(0)"
                        class="btn"
                        :class="{ disabled: recipientPage <= 1 || recipientsLoading }"
                        @click.prevent="onRecipientPrev"
                      >
                        Sebelumnya
                      </a>
                      <span class="afu-page-label">Halaman</span>
                      <input
                        v-model.number="recipientPageInput"
                        type="number"
                        min="1"
                        :max="recipientLastPage"
                        class="afu-page-input"
                        :disabled="recipientsLoading"
                        @keyup.enter="onRecipientPageChange(recipientPageInput)"
                      />
                      <span class="afu-page-label">dari {{ recipientLastPage }}</span>
                      <a
                        href="javascript:void(0)"
                        class="btn"
                        :class="{
                          disabled:
                            recipientPage >= recipientLastPage || recipientsLoading
                        }"
                        @click.prevent="onRecipientNext"
                      >
                        Berikutnya
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-show="activeTab === 'history'">
              <div class="card afu-detail-card">
                <div class="card-header afu-card-header">
                  <div>
                    <h5>Riwayat Aktivitas</h5>
                    <small class="text-muted">
                      Aktivitas terbaru dari alur ini. “Berhasil dikirim” berarti
                      Waajo sudah mengirim pesan, bukan berarti pesan sudah
                      dibaca. Beberapa status, seperti tidak jadi dikirim atau
                      dibatalkan, mungkin tidak muncul sebagai aktivitas
                      terpisah.
                    </small>
                  </div>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary"
                    :disabled="eventsLoading"
                    @click="loadEvents()"
                  >
                    <i class="fa fa-refresh" :class="{ 'fa-spin': eventsLoading }"></i>
                    Muat Ulang
                  </button>
                </div>
                <div class="card-body">
                  <div v-if="eventsError" class="alert alert-danger d-flex align-items-center justify-content-between flex-wrap">
                    <span>
                      <i class="fa fa-exclamation-triangle"></i>
                      {{ eventsError }}
                    </span>
                    <button type="button" class="btn btn-sm btn-outline-danger" :disabled="eventsLoading" @click="loadEvents()">
                      Coba Lagi
                    </button>
                  </div>

                  <div v-if="eventsLoading && !events.length" class="py-4">
                    <Skeleton :count="6" height="52px" gap="10px" />
                  </div>
                  <div v-else-if="!eventsLoading && !events.length && !eventsError" class="afu-empty-inline py-5">
                    <i class="fa fa-history fa-2x text-muted"></i>
                    <h6 class="mt-3">Belum ada aktivitas</h6>
                    <p class="text-muted mb-0">Aktivitas akan muncul setelah alur berjalan.</p>
                  </div>
                  <div v-else-if="events.length" class="afu-event-list">
                    <div v-for="event in events" :key="event.id" class="afu-event-item">
                      <span class="afu-event-dot" :class="eventTone(event.event_type)"></span>
                      <div class="afu-event-main">
                        <div class="afu-event-head">
                          <strong>{{ eventTypeLabel(event.event_type) }}</strong>
                          <span>{{ formatDate(event.create_datetime) }}</span>
                        </div>
                        <div class="afu-event-meta">
                          <span v-if="eventRecipientLabel(event)">
                            <i class="fa fa-user"></i>
                            {{ eventRecipientLabel(event) }}
                          </span>
                          <button
                            v-if="event.recipient_id"
                            type="button"
                            class="btn btn-sm btn-link p-0 ml-2"
                            @click="openRecipientHistoryById(event.recipient_id)"
                          >
                            Riwayat kontak
                          </button>
                        </div>
                        <div v-if="eventDetailText(event)" class="afu-event-detail">
                          {{ eventDetailText(event) }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="events.length" class="afu-pagination">
                    <div class="afu-pagination-left">
                      <span>{{ formatNumber(eventsTotal) }} aktivitas</span>
                    </div>
                    <div class="afu-pagination-right">
                      <a
                        href="javascript:void(0)"
                        class="btn"
                        :class="{ disabled: eventsPage <= 1 || eventsLoading }"
                        @click.prevent="onEventsPrev"
                      >
                        Sebelumnya
                      </a>
                      <span class="afu-page-label">Halaman</span>
                      <input
                        v-model.number="eventsPageInput"
                        type="number"
                        min="1"
                        :max="eventsLastPage"
                        class="afu-page-input"
                        :disabled="eventsLoading"
                        @keyup.enter="onEventsPageChange(eventsPageInput)"
                      />
                      <span class="afu-page-label">dari {{ eventsLastPage }}</span>
                      <a
                        href="javascript:void(0)"
                        class="btn"
                        :class="{
                          disabled: eventsPage >= eventsLastPage || eventsLoading
                        }"
                        @click.prevent="onEventsNext"
                      >
                        Berikutnya
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <a-modal
      :visible="historyVisible"
      :title="historyTitle"
      :footer="null"
      width="760px"
      wrap-class-name="afu-history-modal"
      @cancel="closeHistory"
    >
      <div v-if="historyLoading" class="afu-detail-loading">
        <i class="fa fa-spinner fa-spin"></i>
        Memuat riwayat aktivitas...
      </div>
      <div v-else-if="historyError" class="alert alert-danger d-flex align-items-center justify-content-between flex-wrap">
        <span>{{ historyError }}</span>
        <button type="button" class="btn btn-sm btn-outline-danger" @click="loadRecipientHistory(1)">
          Coba Lagi
        </button>
      </div>
      <template v-else>
        <div class="alert alert-info afu-api-note mb-3">
          “Berhasil dikirim” berarti Waajo sudah mengirim pesan, bukan berarti
          pesan sudah dibaca. Riwayat mengikuti aktivitas yang tersedia; beberapa
          status mungkin tidak muncul sebagai aktivitas terpisah.
        </div>
        <div v-if="!historyRows.length" class="afu-empty-inline py-4">
          <i class="fa fa-history fa-2x text-muted"></i>
          <p class="text-muted mb-0 mt-3">Belum ada aktivitas untuk kontak ini.</p>
        </div>
        <div v-else class="afu-event-list">
          <div v-for="event in historyRows" :key="event.id" class="afu-event-item">
            <span class="afu-event-dot" :class="eventTone(event.event_type)"></span>
            <div class="afu-event-main">
              <div class="afu-event-head">
                <strong>{{ eventTypeLabel(event.event_type) }}</strong>
                <span>{{ formatDate(event.create_datetime) }}</span>
              </div>
              <div v-if="eventDetailText(event)" class="afu-event-detail">
                {{ eventDetailText(event) }}
              </div>
            </div>
          </div>
        </div>

        <div v-if="historyRows.length" class="afu-pagination">
          <div class="afu-pagination-left">
            <span>{{ formatNumber(historyTotal) }} aktivitas</span>
          </div>
          <div class="afu-pagination-right">
            <a
              href="javascript:void(0)"
              class="btn"
              :class="{ disabled: historyPage <= 1 || historyLoading }"
              @click.prevent="onHistoryPrev"
            >
              Sebelumnya
            </a>
            <span class="afu-page-label">Halaman</span>
            <input
              v-model.number="historyPageInput"
              type="number"
              min="1"
              :max="historyLastPage"
              class="afu-page-input"
              :disabled="historyLoading"
              @keyup.enter="onHistoryPageChange(historyPageInput)"
            />
            <span class="afu-page-label">dari {{ historyLastPage }}</span>
            <a
              href="javascript:void(0)"
              class="btn"
              :class="{ disabled: historyPage >= historyLastPage || historyLoading }"
              @click.prevent="onHistoryNext"
            >
              Berikutnya
            </a>
          </div>
        </div>
      </template>

      <div class="text-right mt-3">
        <button type="button" class="btn btn-outline-secondary" @click="closeHistory">
          Tutup
        </button>
      </div>
    </a-modal>

    <a-modal
      :visible="templateModalVisible"
      title="Simpan sebagai Template"
      :footer="null"
      :closable="!templateSaving"
      :mask-closable="false"
      wrap-class-name="afu-template-save-modal"
      @cancel="closeTemplateModal"
    >
      <p class="text-muted">
        Template menyimpan susunan pesan dan pengaturan alur. Kontak penerima,
        jadwal, dan riwayat pengiriman tidak ikut disimpan.
      </p>
      <div class="form-group">
        <label>Nama template <span class="text-danger">*</span></label>
        <input
          v-model="templateName"
          type="text"
          class="form-control"
          maxlength="255"
          placeholder="Contoh: Template Follow Up Promo"
          :disabled="templateSaving"
        />
      </div>
      <div class="form-group">
        <label>Deskripsi (opsional)</label>
        <textarea
          v-model="templateDescription"
          class="form-control"
          rows="3"
          placeholder="Keterangan singkat tentang template ini"
          :disabled="templateSaving"
        ></textarea>
      </div>
      <div v-if="templateError" class="alert alert-danger">
        {{ templateError }}
      </div>
      <div class="text-right">
        <button
          type="button"
          class="btn btn-outline-secondary mr-2"
          :disabled="templateSaving"
          @click="closeTemplateModal"
        >
          Batal
        </button>
        <button
          type="button"
          class="btn afu-primary-btn"
          :disabled="templateSaving"
          @click="saveTemplate"
        >
          <i :class="templateSaving ? 'fa fa-spinner fa-spin' : 'fa fa-save'"></i>
          {{ templateSaving ? "Menyimpan..." : "Simpan Template" }}
        </button>
      </div>
    </a-modal>

    <a-modal
      :visible="quotaDetailVisible"
      title="Detail Kuota Lisensi"
      :footer="null"
      :closable="true"
      wrap-class-name="afu-history-modal"
      @cancel="quotaDetailVisible = false"
    >
      <div v-if="quotaInfo">
        <p class="text-muted mb-3">
          Kuota ini dipakai bersama oleh semua Auto Follow Up yang memakai lisensi
          {{ quotaInfo.license_phone_number || quotaInfo.license_id }}.
        </p>
        <div class="afu-quota-detail-row"><span>Batas kontak harian</span><strong>{{ quotaInfo.daily_limit }} kontak</strong></div>
        <div class="afu-quota-detail-row"><span>Kontak terkirim</span><strong>{{ quotaInfo.sent_count }} kontak</strong></div>
        <div class="afu-quota-detail-row"><span>Kontak reservasi</span><strong>{{ quotaInfo.reserved_count }} kontak</strong></div>
        <div class="afu-quota-detail-row"><span>Kontak terpakai</span><strong>{{ quotaInfo.used_count || 0 }} kontak</strong></div>
        <div class="afu-quota-detail-row"><span>Kontak gagal</span><strong>{{ quotaInfo.failed_count }} kontak</strong></div>
        <div class="afu-quota-detail-row"><span>Sisa kuota</span><strong>{{ quotaInfo.remaining_count }} kontak</strong></div>
        <div class="afu-quota-detail-row"><span>Reset berikutnya</span><strong>{{ formatScheduleDate(quotaInfo.reset_at, quotaInfo.timezone) }}</strong></div>
        <p class="afu-small-note mt-3 mb-0">
          Pesan yang sudah terkirim tetap dihitung. Reset tidak menghapus histori pengiriman
          dan tidak mengubah status flow.
        </p>
      </div>
    </a-modal>

    <a-modal
      :visible="quotaResetVisible"
      title="Reset Limit Lisensi"
      :footer="null"
      :closable="!quotaActionLoading"
      wrap-class-name="afu-history-modal"
      @cancel="closeQuotaReset"
    >
      <div v-if="quotaInfo">
        <p class="text-muted">
          Tindakan ini akan merekonsiliasi reservasi yang tertinggal. Pesan yang sudah
          terkirim tidak dihapus. Anda juga dapat menaikkan batas harian lisensi.
        </p>
        <div class="afu-inline-warning mb-3">
          Lisensi: {{ quotaInfo.license_phone_number || quotaInfo.license_id }} ·
          Penggunaan saat ini {{ quotaInfo.sent_count }} kontak terkirim +
          {{ quotaInfo.reserved_count }} kontak reservasi dari {{ quotaInfo.daily_limit }} kontak.
        </div>
        <div class="form-group">
          <label>Alasan reset <span class="text-danger">*</span></label>
          <textarea
            v-model="quotaResetReason"
            class="form-control"
            rows="3"
            maxlength="500"
            :disabled="quotaActionLoading"
            placeholder="Contoh: reservasi tertinggal setelah flow dibatalkan"
          ></textarea>
        </div>
        <div class="form-group">
          <label>Batas kontak baru per hari (opsional)</label>
          <input
            v-model.number="quotaResetLimit"
            type="number"
            min="1"
            max="100000"
            class="form-control"
            :disabled="quotaActionLoading"
          />
          <small class="text-muted">Kosongkan jika hanya ingin merekonsiliasi reservasi.</small>
        </div>
        <div v-if="quotaActionError" class="afu-inline-warning mb-3">{{ quotaActionError }}</div>
        <div class="text-right">
          <button type="button" class="btn btn-light" :disabled="quotaActionLoading" @click="closeQuotaReset">Batal</button>
          <button type="button" class="btn btn-danger ml-2" :disabled="quotaActionLoading" @click="resetQuota">
            <i class="fa" :class="quotaActionLoading ? 'fa-spinner fa-spin' : 'fa-check'"></i>
            Konfirmasi Reset
          </button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { Skeleton } from "vue-loading-skeleton";
import { formatLocalDate } from "@/utils/helper";
import { friendlyTemplateError } from "@/utils/autoFollowUpTemplateError";
import AfuWhatsAppPreview from "./components/AfuWhatsAppPreview.vue";

const FLOW_STATUS_LABELS = {
  draft: "Draf",
  active: "Aktif",
  paused: "Dijeda",
  completed: "Selesai",
  cancelled: "Dibatalkan"
};

const RECIPIENT_STATUS_LABELS = {
  pending: "Menunggu",
  in_progress: "Sedang Diproses",
  replied: "Membalas",
  completed: "Selesai",
  stopped: "Dihentikan",
  failed: "Gagal Dikirim"
};

const SOURCE_TYPE_LABELS = {
  group: "Grup",
  tag: "Tag",
  manual: "Kontak"
};

const MESSAGE_TYPE_LABELS = {
  text: "Teks",
  image: "Gambar",
  video: "Video",
  document: "Dokumen"
};

const DELAY_UNIT_LABELS = {
  minute: "menit",
  hour: "jam",
  day: "hari"
};

const STOP_REASON_LABELS = {
  manual_stop: "Dihentikan oleh pengguna",
  customer_replied: "Kontak membalas",
  flow_cancelled: "Alur dibatalkan",
  flow_deleted: "Alur dihapus",
  message_failed: "Pesan gagal dikirim",
  uncertain_delivery: "Hasil pengiriman belum pasti",
  enqueue_failed: "Gagal masuk antrean pengiriman",
  outside_sending_window: "Di luar jam pengiriman",
  daily_limit_reached: "Batas pengiriman harian tercapai",
  waiting_delay: "Menunggu jeda antar-pesan",
  prepare_missing: "Data pengiriman belum lengkap",
  waiting_schedule: "Menunggu jadwal berikutnya",
  task_check_uncertain: "Status antrean belum dapat dipastikan",
  task_baru_dibuat: "Pesan dijadwalkan ulang",
  menunggu_jadwal_berikutnya: "Menunggu jadwal berikutnya",
  menunggu_jeda_antar_pesan: "Menunggu jeda antar-pesan",
  batas_harian_tercapai: "Batas pengiriman harian tercapai",
  pesan_sudah_terkirim: "Pesan sudah terkirim",
  penerima_tidak_lagi_aktif: "Penerima tidak lagi aktif",
  pelanggan_sudah_membalas: "Pelanggan sudah membalas",
  menunggu_tahap_sebelumnya: "Menunggu tahap sebelumnya",
  hasil_pengiriman_belum_pasti: "Hasil pengiriman belum pasti",
  pesan_gagal_permanen: "Pesan gagal permanen",
  task_sudah_selesai: "Pesan sudah selesai diproses",
  menunggu_rekonsiliasi_task: "Menunggu pemeriksaan sistem",
  menunggu_pemeriksaan_antrean: "Menunggu pemeriksaan antrean",
  sedang_diproses_worker: "Sedang diproses",
  sedang_disiapkan_scheduler: "Sedang menyiapkan pengiriman",
  belum_waktunya: "Belum waktunya dikirim",
  menunggu_retry_otomatis: "Menunggu percobaan berikutnya"
};

const EVENT_TYPE_LABELS = {
  flow_created: "Alur dibuat",
  flow_activated: "Alur diaktifkan",
  flow_paused: "Alur dijeda",
  flow_resumed: "Alur dilanjutkan",
  flow_cancelled: "Alur dibatalkan",
  recipient_added: "Kontak penerima ditambahkan",
  message_scheduled: "Pesan dijadwalkan",
  message_queued: "Pesan menunggu giliran dikirim",
  message_requeued: "Pesan dijadwalkan ulang",
  message_uncertain: "Hasil pengiriman belum pasti",
  prepare_created: "Pengiriman mulai disiapkan",
  prepare_insert_failed: "Pengiriman belum dapat disiapkan",
  prepare_lookup_failed: "Data pengiriman belum dapat dibaca",
  prepare_reset_failed: "Pengiriman belum dapat diperbarui",
  quota_reservation_failed: "Kuota pengiriman belum tersedia",
  scheduler_error: "Jadwal perlu diperiksa",
  sender_not_ready: "Nomor pengirim belum siap",
  redis_enqueue_success: "Pengiriman masuk antrean",
  redis_enqueue_failed: "Pengiriman belum masuk antrean",
  task_id_persisted: "Status pengiriman tersimpan",
  task_id_persist_failed: "Status pengiriman sedang dipulihkan",
  reconciliation_recovered: "Status pengiriman dipulihkan",
  message_sent: "Pesan berhasil dikirim",
  message_failed: "Pesan gagal dikirim",
  customer_replied: "Kontak membalas",
  recipient_stopped: "Follow up kontak dihentikan",
  recipient_completed: "Follow up kontak selesai",
  daily_limit_reached: "Batas pengiriman harian tercapai",
  sender_disconnected: "Nomor WhatsApp pengirim terputus",
  retry_scheduling_requested: "Pemeriksaan jadwal dimulai",
  retry_scheduling_completed: "Pemeriksaan jadwal selesai",
  retry_message_reconciled: "Status pesan dipulihkan",
  retry_message_scheduled: "Pesan dijadwalkan ulang",
  retry_message_deferred: "Pesan menunggu jadwal berikutnya",
  retry_message_not_eligible: "Pesan belum perlu dijadwalkan ulang",
  retry_message_failed: "Pesan belum dapat dijadwalkan ulang",
  flow_cancel_requested: "Permintaan pembatalan alur",
  flow_cancel_completed: "Pembatalan alur selesai",
  task_delete_requested: "Pembersihan antrean dimulai",
  task_deleted: "Antrean pesan dibatalkan",
  task_cancel_requested: "Pembatalan pengiriman aktif diminta",
  task_cancelled: "Pengiriman aktif dibatalkan",
  task_already_processing: "Pengiriman sedang diproses",
  task_delete_failed: "Sebagian antrean belum dapat dibersihkan"
};

const SCHEDULE_STATE_LABELS = {
  not_scheduled: "Belum dijadwalkan",
  scheduled: "Terjadwal",
  waiting_enqueue: "Menunggu antrean pengiriman",
  waiting_worker: "Sedang diproses",
  processing: "Sedang diproses",
  waiting_retry: "Menunggu retry",
  overdue: "Jadwal terlewat",
  uncertain: "Hasil pengiriman belum pasti",
  failed: "Tidak dapat dijadwalkan",
  paused: "Dijeda",
  completed: "Selesai",
  stopped: "Dihentikan",
  replied: "Dibalas pelanggan",
  cancelled: "Dibatalkan"
};

function scheduleStateTone(state) {
  if (["overdue", "uncertain", "failed"].indexOf(state) !== -1) {
    return "danger";
  }
  if (
    ["waiting_enqueue", "waiting_worker", "waiting_retry", "processing"].indexOf(
      state
    ) !== -1
  ) {
    return "warning";
  }
  if (state === "scheduled") {
    return "info";
  }
  if (state === "completed") {
    return "success";
  }
  return "muted";
}

function queryId(value) {
  return Array.isArray(value) ? value[0] || "" : value || "";
}

export default {
  name: "auto-follow-up-detail",
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    // Vue 2 me-resolve <afu-whatsapp-preview> ke "AfuWhatsappPreview",
    // jadi key registrasi harus sama persis dengan tag kebab.
    "afu-whatsapp-preview": AfuWhatsAppPreview
  },
  data() {
    return {
      flowId: "",
      pageLoading: false,
      refreshing: false,
      loadError: "",
      actionError: "",
      actionLoading: "",
      retrySummaryMessage: "",
      templateModalVisible: false,
      templateName: "",
      templateDescription: "",
      templateSaving: false,
      templateError: "",
      quotaLoading: false,
      quotaError: "",
      quotaActionLoading: "",
      quotaActionError: "",
      quotaDetailVisible: false,
      quotaResetVisible: false,
      quotaResetReason: "",
      quotaResetLimit: null,
      flow: null,
      steps: [],
      previewStepIndex: 0,
      sources: [],
      stats: null,
      statsLoading: false,
      statsError: "",
      license: null,
      licenseError: "",
      activeTab: "overview",
      recipients: [],
      recipientsLoading: false,
      recipientsError: "",
      recipientFilters: {
        search: "",
        status: ""
      },
      recipientPage: 1,
      recipientPageInput: 1,
      recipientPerPage: 20,
      recipientTotal: 0,
      recipientTotalPages: 0,
      recipientActionId: "",
      recipientDirectory: {},
      recipientStatusOptions: [
        { value: "", label: "Semua Status" },
        { value: "pending", label: "Menunggu" },
        { value: "in_progress", label: "Sedang Diproses" },
        { value: "replied", label: "Membalas" },
        { value: "completed", label: "Selesai" },
        { value: "stopped", label: "Dihentikan" },
        { value: "failed", label: "Gagal Dikirim" }
      ],
      events: [],
      eventsLoading: false,
      eventsLoaded: false,
      eventsError: "",
      eventsPage: 1,
      eventsPageInput: 1,
      eventsPerPage: 20,
      eventsTotal: 0,
      eventsTotalPages: 0,
      historyVisible: false,
      historyRecipient: null,
      historyRows: [],
      historyLoading: false,
      historyError: "",
      historyPage: 1,
      historyPageInput: 1,
      historyPerPage: 20,
      historyTotal: 0,
      historyTotalPages: 0,
      statCards: [
        { key: "total_recipients", label: "Total Kontak", icon: "fa fa-users", tone: "blue", hint: "Jumlah kontak yang ditentukan saat alur diaktifkan." },
        { key: "progress_recipients", label: "Menunggu & Sedang Diproses", icon: "fa fa-spinner", tone: "orange", hint: "Kontak yang masih menunggu atau sedang diproses." },
        { key: "completed_recipients", label: "Selesai", icon: "fa fa-check-circle", tone: "green", hint: "Kontak yang sudah menyelesaikan seluruh rangkaian pesan." },
        { key: "sent_messages", label: "Pesan Berhasil Dikirim", icon: "fa fa-paper-plane", tone: "purple", hint: "Waajo sudah mengirim pesan, tetapi belum tentu sudah dibaca." }
      ],
      recipientMetrics: [
        { key: "total_recipients", label: "Total kontak", hint: "Kontak yang ditentukan saat alur diaktifkan." },
        { key: "pending_recipients", label: "Menunggu", hint: "Kontak yang belum diproses." },
        { key: "progress_recipients", label: "Menunggu & sedang diproses", hint: "Gabungan kontak yang menunggu dan sedang diproses." },
        { key: "completed_recipients", label: "Selesai", hint: "Kontak yang sudah menyelesaikan seluruh pesan." },
        { key: "replied_recipients", label: "Membalas", hint: "Kontak yang membalas dan follow up-nya dihentikan." },
        { key: "stopped_recipients", label: "Dihentikan atau gagal", hint: "Kontak yang dihentikan dan yang gagal." },
        { key: "failed_recipients", label: "Gagal", hint: "Bagian dari angka di atas." }
      ],
      messageMetrics: [
        { key: "scheduled_messages", label: "Dijadwalkan", hint: "Sudah dijadwalkan, belum menunggu giliran." },
        { key: "queued_messages", label: "Menunggu giliran dikirim", hint: "Sudah masuk antrean, belum tentu terkirim." },
        { key: "processing_messages", label: "Sedang diproses", hint: "Sedang diproses oleh sistem pengiriman." },
        { key: "sent_messages", label: "Berhasil dikirim", hint: "Waajo sudah mengirim pesan, belum tentu sudah dibaca." },
        { key: "failed_messages", label: "Gagal dikirim", hint: "Gagal setelah beberapa kali percobaan." },
        { key: "uncertain_messages", label: "Hasil pengiriman belum pasti", hint: "Sistem sempat memproses pesan, tetapi hasil pengirimannya belum dapat dipastikan. Pesan tidak dikirim ulang otomatis." },
        { key: "skipped_messages", label: "Tidak jadi dikirim", hint: "Tidak jadi dikirim karena alur dihentikan atau dibatalkan." },
        { key: "cancelled_messages", label: "Dibatalkan", hint: "Dibatalkan sebelum diproses." }
      ]
    };
  },
  computed: {
    autoSwitchEnabled() {
      const session = this.$store.state.login.memberSession || {};
      return session.auto_switching_status == 1;
    },
    canActivate() {
      return this.flow && this.flow.status === "draft";
    },
    quotaInfo() {
      if (this.flow && this.flow.quota) {
        return this.flow.quota;
      }
      if (this.stats && this.stats.quota) {
        return this.stats.quota;
      }
      return null;
    },
    quotaLicenseId() {
      if (this.flow && this.flow.license_id) {
        return this.flow.license_id;
      }
      return this.license && this.license.id ? this.license.id : "";
    },
    canPause() {
      return this.flow && this.flow.status === "active";
    },
    canResume() {
      return this.flow && this.flow.status === "paused";
    },
    canCancel() {
      return (
        this.flow &&
        ["active", "paused"].indexOf(this.flow.status) !== -1
      );
    },
    canRetrySchedule() {
      return !!(
        this.flow &&
        this.flow.status === "active" &&
        (this.scheduleInfo.canRetry || this.scheduleInfo.retryCandidateCount > 0)
      );
    },
    canDelete() {
      return (
        this.flow &&
        ["draft", "completed", "cancelled"].indexOf(this.flow.status) !== -1
      );
    },
    canEdit() {
      return (
        this.flow &&
        ["draft", "active", "paused"].indexOf(this.flow.status) !== -1
      );
    },
    canSaveTemplate() {
      return !!(
        this.flow &&
        Array.isArray(this.steps) &&
        this.steps.length > 0 &&
        Array.isArray(this.sources) &&
        this.sources.length > 0
      );
    },
    recipientLastPage() {
      return Math.max(this.recipientTotalPages || 0, 1);
    },
    eventsLastPage() {
      return Math.max(this.eventsTotalPages || 0, 1);
    },
    historyLastPage() {
      return Math.max(this.historyTotalPages || 0, 1);
    },
    licenseLabel() {
      if (!this.license) {
        return "Nomor pengirim belum tersedia";
      }
      const parts = [
        this.license.license_name ||
          this.license.license_phone_number ||
          "Nomor WhatsApp"
      ];
      if (
        this.license.license_phone_number &&
        this.license.license_phone_number !== parts[0]
      ) {
        parts.push(this.license.license_phone_number);
      }
      return parts.join(" — ");
    },
    delayRangeText() {
      if (!this.flow) {
        return "-";
      }
      const min = Number(this.flow.message_delay_min_seconds) || 0;
      const max = Number(this.flow.message_delay_max_seconds) || 0;
      if (min > 0 && max > 0 && min % 60 === 0 && max % 60 === 0) {
        return min / 60 + "–" + max / 60 + " menit";
      }
      return min + "–" + max + " detik";
    },
    scheduleInfo() {
      const flow = this.flow || {};
      const statsSchedule =
        this.stats &&
        this.stats.schedule &&
        typeof this.stats.schedule === "object" &&
        typeof this.stats.schedule.schedule_state !== "undefined"
          ? this.stats.schedule
          : null;
      const flowSchedule =
        flow.schedule && typeof flow.schedule === "object"
          ? flow.schedule
          : null;
      const source = statsSchedule || flowSchedule || flow;
      const legacyStatsNext =
        !statsSchedule && this.stats
          ? Number(this.stats.next_scheduled_at) || 0
          : 0;
      return {
        nextScheduledAt:
          Number(source.next_scheduled_at || legacyStatsNext) || 0,
        state: source.schedule_state || "",
        label: source.schedule_label || "",
        reason: source.schedule_reason || "",
        reasonCode: source.schedule_reason_code || "",
        serverTime: Number(source.server_time) || 0,
        prepareId: source.prepare_id || "",
        asynqTaskId: source.asynq_task_id || "",
        asynqQueue: source.asynq_queue || "",
        asynqTaskType: source.asynq_task_type || "",
        prepareStatus: Number(source.prepare_status),
        cronStatus: Number(source.cron_status),
        workerStatus: source.worker_status || "",
        errorCode: source.error_code || "",
        lastEnqueueAt: Number(source.last_enqueue_at) || 0,
        enqueueFailures: Number(source.enqueue_failures) || 0,
        retryCandidateCount: Number(source.retry_candidate_count) || 0,
        canRetry: !!source.can_retry,
        retryLabel: source.retry_label || "",
        timezone: flow.timezone || "Asia/Jakarta"
      };
    },
    nextScheduleText() {
      const info = this.scheduleInfo;
      if (info.nextScheduledAt > 0) {
        return this.formatScheduleDate(info.nextScheduledAt, info.timezone);
      }
      return (
        this.scheduleDisplayLabel(
          info.state,
          info.label,
          info.errorCode,
          info.reasonCode,
          info.prepareStatus,
          info.nextScheduledAt,
          info.serverTime
        ) || "Belum dijadwalkan"
      );
    },
    nextScheduleBadge() {
      const info = this.scheduleInfo;
      if (info.nextScheduledAt <= 0) {
        return "";
      }
      return this.scheduleDisplayLabel(
        info.state,
        info.label,
        info.errorCode,
        info.reasonCode,
        info.prepareStatus,
        info.nextScheduledAt,
        info.serverTime
      );
    },
    nextScheduleReason() {
      return this.scheduleReasonText(
        this.scheduleInfo.reasonCode,
        this.scheduleInfo.errorCode,
        this.scheduleInfo.state
      );
    },
    lastActivityText() {
      if (!this.stats) {
        return "-";
      }
      if (this.stats.last_activity_at) {
        return this.formatDate(this.stats.last_activity_at);
      }
      return this.flow ? this.formatDate(this.flow.update_datetime) : "-";
    },
    dailyUsage() {
      return this.stats && Array.isArray(this.stats.daily_usage)
        ? this.stats.daily_usage
        : [];
    },
    historyTitle() {
      if (!this.historyRecipient) {
        return "Riwayat Kontak";
      }
      const name = this.historyRecipient.contact_name || "Kontak";
      const phone = this.historyRecipient.contact_phone
        ? " — " + this.historyRecipient.contact_phone
        : "";
      return "Riwayat " + name + phone;
    }
  },
  watch: {
    "$route.query.id": function (value) {
      const id = queryId(value);
      if (id === this.flowId) {
        return;
      }
      this.initialize(id);
    }
  },
  created() {
    this.initialize(queryId(this.$route.query.id));
  },
  methods: {
    initialize(id) {
      this.flowId = id || "";
      this.pageLoading = true;
      this.loadError = "";
      this.actionError = "";
      this.actionLoading = "";
      this.retrySummaryMessage = "";
      this.flow = null;
      this.steps = [];
      this.previewStepIndex = 0;
      this.sources = [];
      this.stats = null;
      this.statsError = "";
      this.license = null;
      this.licenseError = "";
      this.recipients = [];
      this.recipientsError = "";
      this.recipientPage = 1;
      this.recipientPageInput = 1;
      this.recipientTotal = 0;
      this.recipientTotalPages = 0;
      this.recipientDirectory = {};
      this.recipientFilters = { search: "", status: "" };
      this.events = [];
      this.eventsError = "";
      this.eventsPage = 1;
      this.eventsPageInput = 1;
      this.eventsTotal = 0;
      this.eventsTotalPages = 0;
      this.eventsLoaded = false;
      this.activeTab = "overview";

      if (!this.flowId) {
        this.pageLoading = false;
        this.loadError = "Alur tidak ditemukan. Buka kembali dari halaman daftar.";
        return;
      }

      this.$store
        .dispatch("autoFollowUp/detailAutoFollowUp", { id: this.flowId })
        .then(response => {
          const detail = response && response.data ? response.data : null;
          if (!detail || !detail.id) {
            throw new Error("Alur tidak ditemukan. Buka kembali dari halaman daftar.");
          }
          this.applyDetail(detail);
        })
        .catch(error => {
          this.loadError = this.extractErrorMessage(
            error,
            "Detail alur belum dapat dimuat. Coba lagi."
          );
        })
        .finally(() => {
          this.pageLoading = false;
          if (!this.loadError) {
            this.loadStats();
            this.loadLicense();
            this.loadRecipients();
            this.loadEvents();
            this.loadQuota();
          }
        });
    },
    applyDetail(detail) {
      this.flow = detail;
      this.steps = Array.isArray(detail.steps)
        ? detail.steps.slice().sort((a, b) => Number(a.step_order) - Number(b.step_order))
        : [];
      this.sources = Array.isArray(detail.sources) ? detail.sources : [];
      this.clampPreviewIndex();
    },
    applyQuota(info) {
      if (!info) {
        return;
      }
      if (this.flow) {
        this.flow = Object.assign({}, this.flow, { quota: info });
      }
      if (this.stats) {
        this.stats = Object.assign({}, this.stats, { quota: info });
      }
    },
    loadQuota() {
      if (!this.quotaLicenseId) {
        return Promise.resolve();
      }
      this.quotaLoading = true;
      this.quotaError = "";
      return this.$store
        .dispatch("autoFollowUp/licenseQuotaAutoFollowUp", {
          license_id: this.quotaLicenseId
        })
        .then(response => {
          const info = response && response.data ? response.data : null;
          if (!info) {
            throw new Error("Informasi kuota belum tersedia.");
          }
          this.applyQuota(info);
        })
        .catch(error => {
          this.quotaError = this.extractErrorMessage(
            error,
            "Informasi kuota lisensi belum dapat dimuat."
          );
        })
        .finally(() => {
          this.quotaLoading = false;
        });
    },
    openQuotaDetail() {
      this.quotaDetailVisible = true;
      this.loadQuota();
    },
    openQuotaReset() {
      this.quotaResetReason = "";
      this.quotaResetLimit = null;
      this.quotaActionError = "";
      this.quotaResetVisible = true;
      this.loadQuota();
    },
    closeQuotaReset() {
      if (this.quotaActionLoading) {
        return;
      }
      this.quotaResetVisible = false;
      this.quotaActionError = "";
    },
    reconcileQuota() {
      if (!this.quotaLicenseId || this.quotaActionLoading) {
        return;
      }
      this.$fire({
        title: "Rekonsiliasi reservasi kuota?",
        text:
          "Sistem akan melepas reservasi yang tidak lagi valid. Pesan yang sudah terkirim dan histori pengiriman tidak diubah.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Ya, rekonsiliasi",
        cancelButtonText: "Batal",
        confirmButtonColor: "#FE9B44"
      }).then(result => {
        if (!result || !result.value) {
          return;
        }
        this.quotaActionLoading = "reconcile";
        this.quotaActionError = "";
        this.$store
          .dispatch("autoFollowUp/reconcileLicenseQuotaAutoFollowUp", {
            license_id: this.quotaLicenseId
          })
          .then(response => {
            const info = response && response.data ? response.data : null;
            this.applyQuota(info);
            return this.$fire({
              title: "Rekonsiliasi selesai",
              text: "Reservasi kuota yang tidak valid sudah dilepas.",
              type: "success",
              timer: 2200
            });
          })
          .catch(error => {
            this.quotaActionError = this.extractErrorMessage(
              error,
              "Rekonsiliasi kuota belum dapat dijalankan."
            );
          })
          .finally(() => {
            this.quotaActionLoading = "";
            this.loadQuota();
          });
      });
    },
    resetQuota() {
      if (this.quotaActionLoading) {
        return;
      }
      const reason = (this.quotaResetReason || "").trim();
      if (!reason) {
        this.quotaActionError = "Alasan reset wajib diisi.";
        return;
      }
      const limit = Number(this.quotaResetLimit);
      if (this.quotaResetLimit !== null && this.quotaResetLimit !== "" && (!isFinite(limit) || limit < 1)) {
        this.quotaActionError = "Batas harian baru harus berupa angka lebih dari 0.";
        return;
      }
      this.quotaActionLoading = "reset";
      this.quotaActionError = "";
      const payload = {
        license_id: this.quotaLicenseId,
        reason
      };
      if (this.quotaResetLimit !== null && this.quotaResetLimit !== "") {
        payload.daily_limit = limit;
      }
      this.$store
        .dispatch("autoFollowUp/resetLicenseQuotaAutoFollowUp", payload)
        .then(response => {
          const info = response && response.data ? response.data : null;
          this.applyQuota(info);
          this.quotaResetVisible = false;
          return this.$fire({
            title: "Reset limit selesai",
            text: "Reservasi direkonsiliasi dan batas lisensi diperbarui bila diisi.",
            type: "success",
            timer: 2400
          });
        })
        .catch(error => {
          this.quotaActionError = this.extractErrorMessage(
            error,
            "Reset limit belum dapat dijalankan."
          );
        })
        .finally(() => {
          this.quotaActionLoading = "";
          this.loadQuota();
        });
    },
    clampPreviewIndex() {
      const max = Math.max((this.steps || []).length - 1, 0);
      if (!isFinite(Number(this.previewStepIndex))) {
        this.previewStepIndex = 0;
        return;
      }
      this.previewStepIndex = Math.min(Math.max(this.previewStepIndex, 0), max);
    },
    selectPreviewStep(index) {
      const max = Math.max((this.steps || []).length - 1, 0);
      this.previewStepIndex = Math.min(Math.max(Number(index) || 0, 0), max);
      if (typeof window !== "undefined" && window.innerWidth < 1200) {
        this.$nextTick(() => {
          const panel = this.$el.querySelector(".afu-steps-preview-col");
          if (panel && panel.scrollIntoView) {
            panel.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        });
      }
    },
    loadStats() {
      if (this.statsLoading || !this.flowId) {
        return;
      }
      this.statsLoading = true;
      this.statsError = "";
      this.$store
        .dispatch("autoFollowUp/statsAutoFollowUp", { id: this.flowId })
        .then(response => {
          this.stats = response && response.data ? response.data : null;
          if (!this.stats) {
            this.statsError = "Ringkasan alur belum tersedia.";
          }
        })
        .catch(error => {
          this.statsError = this.extractErrorMessage(
            error,
            "Ringkasan alur belum dapat dimuat. Coba lagi."
          );
        })
        .finally(() => {
          this.statsLoading = false;
        });
    },
    loadLicense() {
      if (!this.flow || !this.flow.license_id) {
        this.license = null;
        return;
      }
      this.licenseError = "";
      this.$store
        .dispatch("license/getLicenseById", this.flow.license_id)
        .then(response => {
          this.license = response && response.data ? response.data : null;
          if (!this.license) {
            this.licenseError = "Informasi nomor pengirim belum tersedia.";
          }
        })
        .catch(() => {
          this.license = null;
          this.licenseError = "Nomor pengirim belum dapat dimuat. Coba lagi.";
        });
    },
    loadRecipients() {
      if (this.recipientsLoading || !this.flowId) {
        return;
      }
      this.recipientsLoading = true;
      this.recipientsError = "";
      this.$store
        .dispatch("autoFollowUp/recipientListAutoFollowUp", {
          id: this.flowId,
          page: this.recipientPage,
          per_page: this.recipientPerPage,
          status: this.recipientFilters.status || "",
          search: this.recipientFilters.search || ""
        })
        .then(response => {
          const data = response && response.data ? response.data : {};
          this.recipients = Array.isArray(data.data) ? data.data : [];
          this.recipientTotal = Number(data.totalRecords) || 0;
          this.recipientPage = Number(data.page) || this.recipientPage;
          this.recipientPerPage = Number(data.perPage) || this.recipientPerPage;
          this.recipientTotalPages = this.recipientPerPage
            ? Math.ceil(this.recipientTotal / this.recipientPerPage)
            : 0;
          this.recipientPageInput = this.recipientPage;
          const directory = Object.assign({}, this.recipientDirectory);
          this.recipients.forEach(row => {
            directory[row.id] = row;
          });
          this.recipientDirectory = directory;
        })
        .catch(error => {
          this.recipientsError = this.extractErrorMessage(
            error,
            "Daftar kontak belum dapat dimuat. Coba lagi."
          );
        })
        .finally(() => {
          this.recipientsLoading = false;
        });
    },
    loadEvents() {
      if (this.eventsLoading || !this.flowId) {
        return;
      }
      this.eventsLoading = true;
      this.eventsError = "";
      this.$store
        .dispatch("autoFollowUp/eventsAutoFollowUp", {
          id: this.flowId,
          page: this.eventsPage,
          per_page: this.eventsPerPage
        })
        .then(response => {
          const data = response && response.data ? response.data : {};
          this.events = Array.isArray(data.data) ? data.data : [];
          this.eventsTotal = Number(data.totalRecords) || 0;
          this.eventsPage = Number(data.page) || this.eventsPage;
          this.eventsPerPage = Number(data.perPage) || this.eventsPerPage;
          this.eventsTotalPages = this.eventsPerPage
            ? Math.ceil(this.eventsTotal / this.eventsPerPage)
            : 0;
          this.eventsPageInput = this.eventsPage;
          this.eventsLoaded = true;
        })
        .catch(error => {
          this.eventsError = this.extractErrorMessage(
            error,
            "Riwayat aktivitas belum dapat dimuat. Coba lagi."
          );
        })
        .finally(() => {
          this.eventsLoading = false;
        });
    },
    refreshAll() {
      if (this.refreshing) {
        return;
      }
      this.refreshing = true;
      this.actionError = "";
      this.$store
        .dispatch("autoFollowUp/detailAutoFollowUp", { id: this.flowId })
        .then(response => {
          const detail = response && response.data ? response.data : null;
          if (!detail || !detail.id) {
            throw new Error("Alur tidak ditemukan. Buka kembali dari halaman daftar.");
          }
          this.applyDetail(detail);
          this.loadStats();
          this.loadLicense();
          this.loadRecipients();
          this.loadEvents();
        })
        .catch(error => {
          this.actionError = this.extractErrorMessage(
            error,
            "Detail alur belum dapat dimuat ulang. Coba lagi."
          );
        })
        .finally(() => {
          this.refreshing = false;
        });
    },
    goToList() {
      this.$router.push("/auto-follow-up");
    },
    goEdit() {
      if (!this.flow) {
        return;
      }
      this.$router.push({
        path: "/auto-follow-up/wizard",
        query: { id: this.flow.id }
      });
    },
    openTemplateModal() {
      if (!this.canSaveTemplate || !this.flow || !this.flow.id) {
        return;
      }
      this.templateName = this.flow.name
        ? this.flow.name + " - Template"
        : "";
      this.templateDescription = this.flow.description || "";
      this.templateError = "";
      this.templateModalVisible = true;
    },
    closeTemplateModal() {
      if (this.templateSaving) {
        return;
      }
      this.templateModalVisible = false;
      this.templateError = "";
    },
    async saveTemplate() {
      if (this.templateSaving || !this.flow || !this.flow.id) {
        return;
      }
      const name = String(this.templateName || "").trim();
      if (!name) {
        this.templateError = "Nama template wajib diisi.";
        return;
      }
      if (name.length > 255) {
        this.templateError = "Nama template maksimal 255 karakter.";
        return;
      }

      this.templateSaving = true;
      this.templateError = "";
      try {
        await this.$store.dispatch("autoFollowUp/templateStoredAutoFollowUp", {
          source_flow_id: this.flow.id,
          name: name,
          description: String(this.templateDescription || "").trim()
        });
      } catch (error) {
        this.templateSaving = false;
        this.templateError = friendlyTemplateError(
          error,
          "Template belum dapat disimpan. Silakan coba lagi."
        );
        return;
      }

      this.templateSaving = false;
      this.templateModalVisible = false;
      this.$fire({
        title: "Berhasil",
        text: "Template berhasil disimpan.",
        type: "success",
        timer: 2200
      });
    },
    retryScheduling() {
      if (!this.flowId || this.actionLoading) {
        return;
      }
      this.$fire({
        title: "Coba jadwalkan ulang?",
        text:
          "Sistem akan memeriksa seluruh pesan pada alur ini. Pesan yang sudah terkirim, sedang diproses, atau masih punya jadwal aktif tidak akan diulang.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Ya, jadwalkan ulang",
        cancelButtonText: "Batal",
        confirmButtonColor: "#FE9B44"
      }).then(result => {
        if (!result || !result.value) {
          return;
        }
        this.actionError = "";
        this.retrySummaryMessage = "";
        this.actionLoading = "retry-scheduling";
        this.$store
          .dispatch("autoFollowUp/retrySchedulingAutoFollowUp", {
            flow_id: this.flowId
          })
          .then(response => {
            const data = response && response.data ? response.data : null;
            this.retrySummaryMessage =
              (data && data.message) || "Jadwal berhasil diperbarui.";
            return this.$store
              .dispatch("autoFollowUp/detailAutoFollowUp", {
                id: this.flowId
              })
              .then(detailResponse => {
                const detail =
                  detailResponse && detailResponse.data
                    ? detailResponse.data
                    : null;
                if (detail && detail.id) {
                  this.applyDetail(detail);
                }
                this.loadStats();
                this.loadRecipients();
                this.loadEvents();
                this.loadQuota();
              });
          })
          .catch(error => {
            this.actionError = this.extractErrorMessage(
              error,
              "Penjadwalan ulang belum berhasil. Coba lagi."
            );
          })
          .finally(() => {
            this.actionLoading = "";
          });
      });
    },
    flowAction(action) {
      if (this.actionLoading) {
        return;
      }
      const config = this.flowActionConfirm(action);
      this.$fire({
        title: config.title,
        text: config.text,
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Ya, lanjutkan",
        cancelButtonText: "Batal",
        confirmButtonColor: "#FE9B44"
      }).then(result => {
        if (!result || !result.value) {
          return;
        }
        this.executeFlowAction(action);
      });
    },
    executeFlowAction(action) {
      this.actionError = "";
      this.actionLoading = action;
      const dispatchMap = {
        activate: "activateAutoFollowUp",
        pause: "pauseAutoFollowUp",
        resume: "resumeAutoFollowUp",
        cancel: "cancelAutoFollowUp",
        delete: "deleteAutoFollowUp"
      };
      const dispatchName = dispatchMap[action];
      if (!dispatchName) {
        this.actionLoading = "";
        return;
      }

      this.$store
        .dispatch("autoFollowUp/" + dispatchName, { id: this.flow.id })
        .then(() => {
          if (action === "delete") {
            return this.$fire({
              title: "Berhasil",
              text: "Alur Follow Up berhasil dihapus.",
              type: "success",
              timer: 2200
            }).then(() => {
              this.actionLoading = "";
              this.$router.push("/auto-follow-up");
            });
          }
          return this.$store
            .dispatch("autoFollowUp/detailAutoFollowUp", {
              id: this.flowId
            })
            .then(response => {
              const detail = response && response.data ? response.data : null;
              if (detail && detail.id) {
                this.applyDetail(detail);
              }
              this.loadStats();
              this.loadRecipients();
              this.loadEvents();
              this.loadQuota();
              return this.$fire({
                title: "Berhasil",
                text: this.flowActionSuccessText(action),
                type: "success",
                timer: 2200
              });
            })
            .then(() => {
              this.actionLoading = "";
            });
        })
        .catch(error => {
          this.actionLoading = "";
          this.actionError = this.extractErrorMessage(
            error,
            "Tindakan belum berhasil. Coba lagi."
          );
        });
    },
    flowActionConfirm(action) {
      const configs = {
        activate: {
          title: "Aktifkan alur Follow Up?",
          text: "Alur akan mulai dijadwalkan. Waajo akan menentukan daftar kontak saat alur diaktifkan. Pastikan sumber kontak dan pesan sudah benar."
        },
        pause: {
          title: "Jeda alur Follow Up?",
          text: "Pesan yang masih menunggu giliran dan belum diambil sistem pengiriman akan ditahan sampai alur dilanjutkan. Pesan yang sudah diproses atau terkirim tidak bisa ditarik."
        },
        resume: {
          title: "Lanjutkan alur Follow Up?",
          text: "Alur akan berjalan lagi. Pesan yang tertunda mengikuti jadwal yang tersimpan."
        },
        cancel: {
          title: "Batalkan alur Follow Up?",
          text: "Pesan yang dijadwalkan akan dibatalkan. Pesan yang masih menunggu giliran dan belum diambil sistem tidak akan dikirim. Pesan yang sudah diproses atau terkirim tidak bisa ditarik. Kontak yang belum selesai akan dihentikan. Tindakan ini tidak bisa dibatalkan."
        },
        delete: {
          title: "Hapus alur Follow Up?",
          text: "Alur akan dihapus dari daftar. Pesan yang dijadwalkan dibatalkan, pesan yang menunggu giliran tidak akan dikirim, dan kontak yang belum selesai dihentikan. Pesan yang sudah diproses atau terkirim tidak bisa ditarik."
        }
      };
      if (configs[action]) {
        return configs[action];
      }
      return {
        title: "Konfirmasi",
        text: "Lanjutkan tindakan ini?"
      };
    },
    flowActionSuccessText(action) {
      const messages = {
        activate: "Alur Follow Up berhasil diaktifkan.",
        pause: "Alur Follow Up berhasil dijeda.",
        resume: "Alur Follow Up berhasil dilanjutkan.",
        cancel: "Alur Follow Up berhasil dibatalkan."
      };
      return messages[action] || "Tindakan berhasil.";
    },
    canStopRecipient(row) {
      return ["pending", "in_progress"].indexOf(row.status) !== -1;
    },
    stopRecipient(row) {
      if (this.recipientActionId) {
        return;
      }
      this.$fire({
        title: "Hentikan follow up untuk kontak ini?",
        text:
          (row.contact_name || row.contact_phone || "Kontak") +
          " akan dihentikan dan jadwal berikutnya dibatalkan. Pesan yang dijadwalkan atau menunggu giliran dan belum diambil sistem tidak akan dikirim. Pesan yang sudah diproses atau terkirim tidak bisa ditarik.",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, hentikan",
        cancelButtonText: "Batal",
        confirmButtonColor: "#FE9B44"
      }).then(result => {
        if (!result || !result.value) {
          return;
        }
        this.recipientActionId = row.id;
        this.$store
          .dispatch("autoFollowUp/stopRecipientAutoFollowUp", {
            recipient_id: row.id
          })
          .then(() => {
            this.loadRecipients();
            this.loadStats();
            this.loadEvents();
            this.$fire({
              title: "Berhasil",
              text: "Follow up untuk kontak ini dihentikan.",
              type: "success",
              timer: 2200
            });
          })
          .catch(error => {
            this.actionError = this.extractErrorMessage(
              error,
              "Follow up kontak belum dapat dihentikan. Coba lagi."
            );
          })
          .finally(() => {
            this.recipientActionId = "";
          });
      });
    },
    activateHistoryTab() {
      this.activeTab = "history";
      if (!this.eventsLoaded) {
        this.loadEvents();
      }
    },
    openRecipientHistory(row) {
      this.historyRecipient = row;
      this.historyVisible = true;
      this.historyRows = [];
      this.historyError = "";
      this.historyPage = 1;
      this.historyPageInput = 1;
      this.historyTotal = 0;
      this.historyTotalPages = 0;
      this.loadRecipientHistory(1);
    },
    openRecipientHistoryById(recipientId) {
      const row =
        this.recipientDirectory[recipientId] || {
          id: recipientId,
          contact_name: "",
          contact_phone: ""
        };
      this.openRecipientHistory(row);
    },
    loadRecipientHistory(page) {
      if (this.historyLoading || !this.flowId || !this.historyRecipient) {
        return;
      }
      this.historyLoading = true;
      this.historyError = "";
      this.historyPage = page || 1;
      this.$store
        .dispatch("autoFollowUp/eventsAutoFollowUp", {
          id: this.flowId,
          recipient_id: this.historyRecipient.id,
          page: this.historyPage,
          per_page: this.historyPerPage
        })
        .then(response => {
          const data = response && response.data ? response.data : {};
          this.historyRows = Array.isArray(data.data) ? data.data : [];
          this.historyTotal = Number(data.totalRecords) || 0;
          this.historyPage = Number(data.page) || this.historyPage;
          this.historyPerPage = Number(data.perPage) || this.historyPerPage;
          this.historyTotalPages = this.historyPerPage
            ? Math.ceil(this.historyTotal / this.historyPerPage)
            : 0;
          this.historyPageInput = this.historyPage;
        })
        .catch(error => {
          this.historyError = this.extractErrorMessage(
            error,
            "Riwayat kontak belum dapat dimuat. Coba lagi."
          );
        })
        .finally(() => {
          this.historyLoading = false;
        });
    },
    closeHistory() {
      this.historyVisible = false;
    },
    onHistoryPageChange(page) {
      const target = Math.min(
        Math.max(Number(page) || 1, 1),
        this.historyLastPage
      );
      if (target === this.historyPage) {
        this.historyPageInput = this.historyPage;
        return;
      }
      this.loadRecipientHistory(target);
    },
    onHistoryPrev() {
      if (this.historyPage > 1) {
        this.loadRecipientHistory(this.historyPage - 1);
      }
    },
    onHistoryNext() {
      if (this.historyPage < this.historyLastPage) {
        this.loadRecipientHistory(this.historyPage + 1);
      }
    },
    applyRecipientFilters() {
      this.recipientPage = 1;
      this.recipientPageInput = 1;
      this.loadRecipients();
    },
    resetRecipientFilters() {
      this.recipientFilters = { search: "", status: "" };
      this.recipientPage = 1;
      this.recipientPageInput = 1;
      this.loadRecipients();
    },
    onRecipientPerPageChange() {
      this.recipientPage = 1;
      this.recipientPageInput = 1;
      this.loadRecipients();
    },
    onRecipientPageChange(page) {
      const target = Math.min(
        Math.max(Number(page) || 1, 1),
        this.recipientLastPage
      );
      if (target === this.recipientPage) {
        this.recipientPageInput = this.recipientPage;
        return;
      }
      this.recipientPage = target;
      this.recipientPageInput = target;
      this.loadRecipients();
    },
    onRecipientPrev() {
      if (this.recipientPage > 1) {
        this.onRecipientPageChange(this.recipientPage - 1);
      }
    },
    onRecipientNext() {
      if (this.recipientPage < this.recipientLastPage) {
        this.onRecipientPageChange(this.recipientPage + 1);
      }
    },
    onEventsPageChange(page) {
      const target = Math.min(
        Math.max(Number(page) || 1, 1),
        this.eventsLastPage
      );
      if (target === this.eventsPage) {
        this.eventsPageInput = this.eventsPage;
        return;
      }
      this.eventsPage = target;
      this.eventsPageInput = target;
      this.loadEvents();
    },
    onEventsPrev() {
      if (this.eventsPage > 1) {
        this.onEventsPageChange(this.eventsPage - 1);
      }
    },
    onEventsNext() {
      if (this.eventsPage < this.eventsLastPage) {
        this.onEventsPageChange(this.eventsPage + 1);
      }
    },
    metricValue(key) {
      if (!this.stats) {
        return "-";
      }
      const value = this.stats[key];
      return typeof value === "undefined" || value === null
        ? "-"
        : this.formatNumber(value);
    },
    stepStat(step) {
      if (!this.stats || !Array.isArray(this.stats.per_step)) {
        return null;
      }
      return (
        this.stats.per_step.find(
          row =>
            String(row.step_id) === String(step.id) ||
            Number(row.step_order) === Number(step.step_order)
        ) || null
      );
    },
    stepStatValue(step, key) {
      const stat = this.stepStat(step);
      if (!stat) {
        return "-";
      }
      return this.formatNumber(stat[key] || 0);
    },
    stepDelayText(index) {
      return index === 0
        ? "Jeda dari kontak masuk"
        : "Jeda dari pesan sebelumnya";
    },
    stepLabel(order) {
      const step = this.steps.find(
        item => Number(item.step_order) === Number(order)
      );
      if (!step) {
        return order ? "Pesan " + order : "Pesan";
      }
      return "Pesan " + order + " — " + (step.name || "Pesan " + order);
    },
    recipientStepText(row) {
      if (row.status === "completed") {
        return row.current_step_order
          ? "Selesai pada " + this.stepLabel(row.current_step_order)
          : "Selesai";
      }
      if (row.status === "replied") {
        return row.current_step_order
          ? "Membalas setelah " + this.stepLabel(row.current_step_order)
          : "Membalas";
      }
      if (row.status === "stopped" || row.status === "failed") {
        return row.current_step_order
          ? "Berhenti setelah " + this.stepLabel(row.current_step_order)
          : "Belum ada pesan";
      }
      if (row.current_step_order) {
        return "Terakhir: " + this.stepLabel(row.current_step_order);
      }
      return "Belum ada pesan";
    },
    recipientNextStepText(row) {
      if (!row.next_scheduled_at) {
        return "";
      }
      if (["replied", "completed", "stopped", "failed"].indexOf(row.status) !== -1) {
        return "";
      }
      const nextOrder = row.current_step_order
        ? Number(row.current_step_order) + 1
        : 1;
      const exists = this.steps.some(
        step => Number(step.step_order) === nextOrder
      );
      return exists ? "Berikutnya: " + this.stepLabel(nextOrder) : "";
    },
    formatNumber(value) {
      const number = Number(value);
      if (!isFinite(number)) {
        return "0";
      }
      return number.toLocaleString("id-ID");
    },
    scheduleStateLabel(state) {
      return SCHEDULE_STATE_LABELS[state] || "";
    },
    scheduleDisplayLabel(
      state,
      label,
      errorCode,
      reasonCode,
      prepareStatus,
      nextScheduledAt,
      serverTime
    ) {
      const code = String(errorCode || "");
      const reason = String(reasonCode || "");
      if (reason === "no_eligible_recipient") {
        return "Tidak ada penerima aktif";
      }
      if (reason === "scheduler_error") {
        return "Data jadwal perlu diperiksa";
      }
      if (reason === "daily_limit_reached") {
        return "Batas harian lisensi tercapai";
      }
      if (reason === "outside_sending_window") {
        return "Di luar jam pengiriman";
      }
      if (reason === "license_quota_reserved") {
        return "Kuota lisensi sedang terpakai";
      }
      if (reason === "sender_not_ready") {
        return "Nomor pengirim belum siap";
      }
      if (reason === "prepare_pending") {
        return "Sedang menyiapkan pengiriman";
      }
      if (reason === "enqueue_pending") {
        return "Menunggu antrean pengiriman";
      }
      if (code.indexOf("prepare_") === 0 || code === "queue_mark_failed") {
        return "Pengiriman belum dapat disiapkan";
      }
      if (code === "enqueue_failed") {
        return "Pengiriman belum masuk antrean";
      }
      if (state === "processing") {
        return "Sedang menyiapkan pengiriman";
      }
      if (state === "waiting_enqueue") {
        return "Menunggu antrean pengiriman";
      }
      if (state === "waiting_worker") {
        return "Sedang diproses";
      }
      if (state === "scheduled" && Number(prepareStatus) < 0) {
        if (Number(nextScheduledAt) > Number(serverTime)) {
          return "Terjadwal";
        }
        return "Menunggu jadwal";
      }
      return label || this.scheduleStateLabel(state) || "Belum dijadwalkan";
    },
    recipientScheduleLabel(row) {
      return this.scheduleDisplayLabel(
        row.schedule_state,
        row.schedule_label,
        row.error_code,
        row.schedule_reason_code,
        row.prepare_status,
        row.next_scheduled_at,
        row.server_time
      );
    },
    scheduleReasonText(reasonCode, errorCode, state) {
      const code = String(reasonCode || errorCode || "");
      const labels = {
        daily_limit_reached: "Batas kontak harian lisensi tercapai. Pengiriman akan dilanjutkan setelah kuota tersedia.",
        quota_reservation_failed: "Kuota lisensi belum dapat dialokasikan. Sistem akan mencoba lagi.",
        sender_not_ready: "Nomor pengirim belum siap. Pastikan WhatsApp terhubung.",
        prepare_insert_failed: "Sistem belum dapat menyiapkan pengiriman. Akan dicoba lagi.",
        prepare_lookup_failed: "Data persiapan pengiriman belum dapat dibaca. Akan dicoba lagi.",
        prepare_reset_failed: "Persiapan pengiriman belum dapat diperbarui. Akan dicoba lagi.",
        redis_enqueue_failed: "Pengiriman belum dapat dimasukkan ke antrean. Akan dicoba lagi.",
        task_id_persist_failed: "Task sudah dibuat, tetapi status teknisnya belum tersimpan. Sistem akan memulihkan otomatis.",
        scheduler_error: "Jadwal belum dapat diproses. Tim teknis dapat memeriksa log sistem.",
        outside_sending_window: "Pengiriman dijadwalkan pada jam kirim berikutnya.",
        prepare_pending: "Pengiriman sedang disiapkan.",
        enqueue_pending: "Pengiriman menunggu dimasukkan ke antrean.",
        no_eligible_recipient: "Tidak ada penerima aktif pada alur ini.",
        waiting_next_schedule: ""
      };
      if (labels[code]) {
        return labels[code];
      }
      if (state === "waiting_retry") {
        return "Pengiriman ditunda sementara dan akan dicoba lagi.";
      }
      return "";
    },
    recipientScheduleReason(row) {
      return this.scheduleReasonText(
        row.schedule_reason_code,
        row.error_code,
        row.schedule_state
      );
    },
    scheduleTone(state) {
      return scheduleStateTone(state);
    },
    recipientScheduleTitle(row) {
      const parts = [];
      const label = this.scheduleDisplayLabel(
        row.schedule_state,
        row.schedule_label,
        row.error_code,
        row.schedule_reason_code,
        row.prepare_status,
        row.next_scheduled_at,
        row.server_time
      );
      if (label) {
        parts.push(label);
      }
      const reason = this.recipientScheduleReason(row);
      if (reason) {
        parts.push(reason);
      }
      return parts.join(" · ");
    },
    timezoneLabel(timezone) {
      const tz = timezone || "Asia/Jakarta";
      if (tz === "Asia/Jakarta") {
        return "WIB";
      }
      if (tz === "Asia/Makassar") {
        return "WITA";
      }
      if (tz === "Asia/Jayapura") {
        return "WIT";
      }
      return tz;
    },
    formatScheduleDate(value, timezone) {
      const unix = Number(value);
      if (!unix || unix <= 0) {
        return "-";
      }
      let effectiveTimezone = timezone || "Asia/Jakarta";
      let formatter = null;
      try {
        formatter = new Intl.DateTimeFormat("id-ID", {
          timeZone: effectiveTimezone,
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false
        });
        formatter.format(new Date(unix * 1000));
      } catch (error) {
        effectiveTimezone = "Asia/Jakarta";
        formatter = new Intl.DateTimeFormat("id-ID", {
          timeZone: effectiveTimezone,
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false
        });
      }
      const parts = {};
      formatter.formatToParts(new Date(unix * 1000)).forEach(part => {
        parts[part.type] = part.value;
      });
      const hour = String(parts.hour || "").padStart(2, "0");
      const minute = String(parts.minute || "").padStart(2, "0");
      return (
        (parts.day || "") +
        " " +
        (parts.month || "") +
        " " +
        (parts.year || "") +
        ", " +
        hour +
        ":" +
        minute +
        " " +
        this.timezoneLabel(effectiveTimezone)
      );
    },
    formatDate(value) {
      const unix = Number(value);
      if (!unix || unix <= 0) {
        return "-";
      }
      return formatLocalDate(unix);
    },
    formatDuration(seconds) {
      const number = Number(seconds) || 0;
      if (number > 0 && number % 60 === 0) {
        return number / 60 + " menit";
      }
      return number + " detik";
    },
    licenseStatusLabel(license) {
      const status = license && license.status_label;
      if (!status) {
        return "";
      }
      const labels = {
        active: "Aktif",
        draft: "Belum aktif",
        expired: "Kedaluwarsa",
        inactive: "Tidak aktif"
      };
      return labels[String(status).toLowerCase()] || "Status tidak diketahui";
    },
    flowStatusLabel(status) {
      return FLOW_STATUS_LABELS[status] || "Status tidak dikenal";
    },
    flowTone(status) {
      return ["draft", "active", "paused", "completed", "cancelled"].indexOf(
        status
      ) !== -1
        ? status
        : "draft";
    },
    recipientStatusLabel(status) {
      return RECIPIENT_STATUS_LABELS[status] || "Status tidak dikenal";
    },
    recipientTone(status) {
      return ["pending", "in_progress", "replied", "completed", "stopped", "failed"].indexOf(
        status
      ) !== -1
        ? status
        : "pending";
    },
    sourceTypeLabel(type) {
      return SOURCE_TYPE_LABELS[type] || "Sumber kontak";
    },
    messageTypeLabel(type) {
      return MESSAGE_TYPE_LABELS[type] || "Pesan";
    },
    delayUnitLabel(unit) {
      return DELAY_UNIT_LABELS[unit] || "";
    },
    stopReasonLabel(reason) {
      if (!reason) {
        return "-";
      }
      return STOP_REASON_LABELS[reason] || "Alasan tidak diketahui";
    },
    eventTypeLabel(type) {
      return EVENT_TYPE_LABELS[type] || "Aktivitas";
    },
    eventTone(type) {
      if (
        type === "message_failed" ||
        type === "sender_disconnected" ||
        type === "prepare_insert_failed" ||
        type === "prepare_lookup_failed" ||
        type === "prepare_reset_failed" ||
        type === "quota_reservation_failed" ||
        type === "redis_enqueue_failed" ||
        type === "task_id_persist_failed" ||
        type === "scheduler_error"
      ) {
        return "danger";
      }
      if (type === "customer_replied" || type === "message_sent") {
        return "success";
      }
      if (
        type === "flow_paused" ||
        type === "daily_limit_reached" ||
        type === "recipient_stopped"
      ) {
        return "warning";
      }
      if (type === "flow_activated" || type === "flow_resumed") {
        return "info";
      }
      return "default";
    },
    eventData(event) {
      if (!event || !event.event_data) {
        return {};
      }
      try {
        const parsed = JSON.parse(event.event_data);
        return parsed && typeof parsed === "object" ? parsed : {};
      } catch (error) {
        return {};
      }
    },
    eventRecipientLabel(event) {
      if (!event || !event.recipient_id) {
        return "";
      }
      const row = this.recipientDirectory[event.recipient_id];
      if (row) {
        return (
          (row.contact_name || "Tanpa nama") +
          (row.contact_phone ? " · " + row.contact_phone : "")
        );
      }
      const data = this.eventData(event);
      if (data.contact_phone) {
        return data.contact_phone;
      }
      return "Kontak";
    },
    eventDetailText(event) {
      const data = this.eventData(event);
      const parts = [];
      if (data.step_order) {
        parts.push("Pesan " + data.step_order);
      }
      if (data.scheduled_at) {
        parts.push("Jadwal " + this.formatDate(data.scheduled_at));
      }
      if (data.reason) {
        parts.push("Alasan: " + this.stopReasonLabel(data.reason));
      }
      if (data.error) {
        parts.push("Ada kendala saat mengirim pesan.");
      }
      if (typeof data.retry_count !== "undefined") {
        parts.push("Sudah dicoba " + data.retry_count + " kali");
      }
      if (data.contact_phone) {
        parts.push("Nomor " + data.contact_phone);
      }
      if (data.recipients) {
        parts.push(data.recipients + " kontak");
      }
      if (data.steps) {
        parts.push(data.steps + " pesan");
      }
      if (data.sources) {
        parts.push(data.sources + " sumber kontak");
      }
      return parts.join(" · ");
    },
    extractErrorMessage(error, fallback) {
      let message = "";
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.msg
      ) {
        message = error.response.data.msg;
      } else if (error && error.message) {
        message = error.message;
      }
      if (!message) {
        return fallback;
      }

      const text = String(message)
        .replace(/<br\s*\/?>/gi, " ")
        .replace(/<[^>]*>/g, "")
        .trim();
      const lower = text.toLowerCase();

      if (lower.indexOf("license") !== -1) {
        return "Nomor WhatsApp pengirim tidak ditemukan atau belum aktif. Pilih nomor lain yang tersedia.";
      }
      if (lower.indexOf("no contacts found") !== -1) {
        return "Belum ada kontak yang sesuai dengan sumber yang dipilih. Periksa grup, tag, atau kontak.";
      }
      if (lower.indexOf("recipient is not found") !== -1) {
        return "Kontak penerima tidak ditemukan. Muat ulang daftar kontak.";
      }
      if (lower.indexOf("only active flows can be paused") !== -1) {
        return "Alur ini belum bisa dijeda karena statusnya tidak aktif.";
      }
      if (lower.indexOf("only paused flows can be resumed") !== -1) {
        return "Alur ini belum bisa dilanjutkan karena tidak sedang dijeda.";
      }
      if (lower.indexOf("only active or paused flows can be cancelled") !== -1) {
        return "Alur ini tidak dapat dibatalkan pada status saat ini.";
      }
      if (
        lower.indexOf("auto follow up flow is not found") !== -1 ||
        lower.indexOf("flow is not found") !== -1
      ) {
        return "Alur tidak ditemukan. Muat ulang halaman daftar.";
      }
      if (lower.indexOf("data yang dikirim tidak valid") !== -1) {
        return "Data yang dikirim belum sesuai. Periksa kembali pengaturan alur.";
      }
      if (lower.indexOf("terjadi kesalahan pada server") !== -1) {
        return "Terjadi kendala saat memproses permintaan. Coba lagi.";
      }
      if (
        lower.indexOf("unauthorized") !== -1 ||
        lower.indexOf("forbidden") !== -1 ||
        lower.indexOf("not authorized") !== -1 ||
        lower.indexOf("permission") !== -1
      ) {
        return "Anda tidak memiliki akses untuk tindakan ini.";
      }
      if (
        lower.indexOf("timeout") !== -1 ||
        lower.indexOf("network") !== -1 ||
        lower.indexOf("connection") !== -1
      ) {
        return "Koneksi bermasalah. Periksa jaringan Anda dan coba lagi.";
      }
      if (lower.indexOf("not found") !== -1) {
        return "Data yang diminta tidak ditemukan. Muat ulang halaman.";
      }
      if (
        lower.indexOf("sql") !== -1 ||
        lower.indexOf("select ") !== -1 ||
        lower.indexOf("table") !== -1 ||
        lower.indexOf("column") !== -1 ||
        lower.indexOf("backend") !== -1 ||
        lower.indexOf("redis") !== -1 ||
        lower.indexOf("worker") !== -1 ||
        lower.indexOf("invalid") !== -1 ||
        lower.indexOf("failed") !== -1 ||
        lower.indexOf("error") !== -1 ||
        text.indexOf("<") !== -1
      ) {
        return fallback;
      }

      return text;
    }
  }
};
</script>

<style scoped>
.afu-beta-inline {
  display: inline-flex;
  align-items: center;
  margin-left: 7px;
  padding: 2px 7px;
  border: 1px solid #ffd8b5;
  border-radius: 999px;
  background: #fff1e5;
  color: #d97a18;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: 0.4px;
  vertical-align: middle;
}

.afu-detail-header-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.afu-detail-card {
  border: 1px solid #e9ecef;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  margin-bottom: 18px;
}

.afu-action-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 18px;
}

.afu-action-bar-left {
  flex: 1 1 auto;
  min-width: 240px;
}

.afu-action-title {
  font-weight: 600;
  color: #343a40;
  margin-bottom: 2px;
}

.afu-action-buttons {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: nowrap;
  justify-content: flex-end;
  gap: 8px;
}

.afu-primary-btn {
  background-color: #fe9b44;
  border-color: #fe9b44;
  color: #ffffff;
}

.afu-primary-btn:hover,
.afu-primary-btn:focus {
  background-color: #f08a2e;
  border-color: #f08a2e;
  color: #ffffff;
}

.afu-primary-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.afu-detail-label {
  font-size: 12px;
  color: #8c8c8c;
  margin-bottom: 4px;
}

.afu-detail-value {
  font-size: 15px;
  font-weight: 600;
  color: #343a40;
}

.afu-small-note {
  font-size: 12px;
  color: #b8860b;
}

.afu-schedule-badge {
  display: inline-flex;
  align-items: center;
  margin-top: 5px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.5;
  white-space: nowrap;
}

.afu-schedule-tone-danger {
  color: #b42318;
  background: #fef3f2;
}

.afu-schedule-tone-warning {
  color: #b45309;
  background: #fff7e8;
}

.afu-schedule-tone-info {
  color: #1a73e8;
  background: #e8f0fe;
}

.afu-schedule-tone-success {
  color: #3f8f34;
  background: #e7f6e4;
}

.afu-schedule-tone-muted {
  color: #6c757d;
  background: #f1f3f5;
}

.afu-quota-card {
  border: 1px solid #e6e8eb;
  border-radius: 10px;
  padding: 14px 16px;
  background: #fff;
}

.afu-quota-summary {
  font-size: 14px;
}

.afu-quota-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.afu-quota-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  margin-right: 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
}

.afu-quota-normal {
  color: #3f8f34;
  background: #e7f6e4;
}

.afu-quota-reached {
  color: #dc3545;
  background: #fdecee;
}

.afu-quota-detail-row {
  display: flex;
  justify-content: space-between;
  padding: 7px 0;
  border-bottom: 1px solid #f0f1f3;
  font-size: 14px;
}

.afu-quota-detail-row:last-child {
  border-bottom: 0;
}

.afu-config-line {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
  padding: 3px 0;
}

.afu-config-line span {
  color: #8c8c8c;
}

.afu-config-line strong {
  color: #343a40;
  text-align: right;
}

.afu-source-row {
  border-top: 1px solid #f1f3f5;
  margin-top: 16px;
  padding-top: 14px;
}

.afu-source-badge {
  display: inline-block;
  background: #e8f0fe;
  color: #1a73e8;
  padding: 5px 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  margin: 0 6px 6px 0;
}

.afu-detail-tabs {
  margin-bottom: 18px;
}

.afu-detail-tabs .nav-link {
  color: #6c757d;
  border: 0;
  border-bottom: 2px solid transparent;
  padding: 10px 14px;
  font-weight: 500;
}

.afu-detail-tabs .nav-link.active {
  color: #fe9b44;
  background: transparent;
  border-bottom-color: #fe9b44;
}

.afu-tab-count {
  display: inline-block;
  background: #f1f3f5;
  color: #6c757d;
  border-radius: 999px;
  padding: 1px 7px;
  margin-left: 4px;
  font-size: 11px;
}

.afu-stat-card {
  border: 1px solid #e9ecef;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  margin-bottom: 16px;
}

.afu-stat-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex: 0 0 44px;
}

.afu-stat-icon.blue {
  background: #e8f0fe;
  color: #1a73e8;
}

.afu-stat-icon.orange {
  background: #fff1e5;
  color: #fe9b44;
}

.afu-stat-icon.green {
  background: #e7f6e4;
  color: #3f8f34;
}

.afu-stat-icon.purple {
  background: #f3e8ff;
  color: #7c3aed;
}

.afu-stat-label {
  font-size: 13px;
  color: #8c8c8c;
}

.afu-stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #343a40;
  line-height: 1.2;
  min-height: 29px;
}

.afu-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid #f1f3f5;
}

.afu-card-header h5 {
  margin: 0 0 2px;
  font-size: 16px;
  font-weight: 600;
}

.afu-section-count {
  background: #f1f3f5;
  color: #6c757d;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.afu-metric-list {
  padding-top: 8px;
  padding-bottom: 8px;
}

.afu-metric-row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 6px 0;
  border-bottom: 1px dashed #f1f3f5;
  font-size: 13px;
}

.afu-metric-row:last-of-type {
  border-bottom: 0;
}

.afu-metric-row span {
  color: #6c757d;
}

.afu-metric-row strong {
  color: #343a40;
}

.afu-steps-layout {
  align-items: flex-start;
}

.afu-steps-preview-col {
  position: sticky;
  top: 92px;
  margin-bottom: 18px;
}

.afu-step-card {
  border: 1px solid #e9ecef;
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 12px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.afu-step-card.is-preview-active {
  border-color: #fe9b44;
  box-shadow: 0 0 0 3px rgba(254, 155, 68, 0.12);
}

.afu-step-card:last-child {
  margin-bottom: 0;
}

.afu-step-header-right {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 8px;
}

.afu-preview-step-btn.is-active {
  color: #ffffff;
  background: #fe9b44;
  border-color: #fe9b44;
}

.afu-preview-step-btn {
  border-radius: 999px;
  font-weight: 600;
}

.afu-step-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}

.afu-step-number {
  display: inline-block;
  background: #fff1e5;
  color: #d97a18;
  border-radius: 999px;
  padding: 3px 9px;
  font-size: 12px;
  font-weight: 700;
}

.afu-step-content {
  white-space: pre-wrap;
  word-break: break-word;
  color: #343a40;
  margin-top: 8px;
}

.afu-step-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  border-top: 1px dashed #f1f3f5;
  margin-top: 12px;
  padding-top: 10px;
  color: #6c757d;
  font-size: 12px;
}

.afu-step-stats strong {
  color: #343a40;
}

.afu-table {
  min-width: 860px;
}

.afu-recipient-table {
  table-layout: fixed;
  min-width: 900px;
}

.afu-recipient-table thead th {
  white-space: normal;
}

.afu-recipient-table tbody td {
  white-space: normal;
  word-break: break-word;
}

.afu-recipient-table th:nth-child(1) {
  width: 14%;
}

.afu-recipient-table th:nth-child(2) {
  width: 10%;
}

.afu-recipient-table th:nth-child(3) {
  width: 23%;
}

.afu-recipient-table th:nth-child(4) {
  width: 15%;
}

.afu-recipient-table th:nth-child(5) {
  width: 17%;
}

.afu-recipient-table th:nth-child(6) {
  width: 21%;
}

.afu-table thead th {
  border-top: 0;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.2px;
  color: #8c8c8c;
  font-weight: 600;
  white-space: nowrap;
}

.afu-table tbody td {
  vertical-align: middle;
  font-size: 13px;
}

.afu-contact-name {
  font-weight: 600;
  color: #343a40;
}

.afu-actions-cell,
.afu-recipient-table td.afu-actions-cell {
  white-space: nowrap;
}

.afu-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.afu-status-badge::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 6px;
  background: currentColor;
}

.afu-status-draft,
.afu-recipient-pending {
  background: #f1f3f5;
  color: #6c757d;
}

.afu-status-active,
.afu-recipient-replied {
  background: #e7f6e4;
  color: #3f8f34;
}

.afu-status-paused,
.afu-recipient-stopped {
  background: #fff1e5;
  color: #d97a18;
}

.afu-status-completed,
.afu-recipient-in_progress {
  background: #e8f0fe;
  color: #1a73e8;
}

.afu-status-cancelled,
.afu-recipient-failed {
  background: #fdecee;
  color: #dc3545;
}

.afu-recipient-completed {
  background: #e6f7f3;
  color: #0f766e;
}

.afu-filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 14px;
}

.afu-filter-search {
  flex: 1 1 260px;
}

.afu-filter-status {
  flex: 0 1 220px;
}

.afu-filter-buttons {
  display: flex;
  gap: 8px;
}

.afu-filter-label {
  display: block;
  font-size: 12px;
  color: #6c757d;
  margin-bottom: 4px;
}

.afu-api-note {
  font-size: 13px;
}

.afu-empty-inline {
  text-align: center;
  color: #8c8c8c;
}

.afu-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 16px;
}

.afu-pagination-left,
.afu-pagination-right {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  color: #6c757d;
  font-size: 13px;
}

.afu-page-label {
  margin: 0 5px;
  color: #6c757d;
  font-size: 13px;
}

.afu-page-input {
  width: 64px;
  height: 34px;
  padding: 4px 6px;
  border: 1px solid #ced4da;
  border-radius: 5px;
  text-align: center;
}

.afu-event-list {
  position: relative;
}

.afu-event-item {
  display: flex;
  gap: 12px;
  padding: 10px 0;
}

.afu-event-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-top: 5px;
  flex: 0 0 10px;
  background: #adb5bd;
}

.afu-event-dot.success {
  background: #3f8f34;
}

.afu-event-dot.warning {
  background: #fe9b44;
}

.afu-event-dot.danger {
  background: #dc3545;
}

.afu-event-dot.info {
  background: #1a73e8;
}

.afu-event-main {
  flex: 1;
  min-width: 0;
}

.afu-event-head {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  font-size: 14px;
}

.afu-event-head span {
  color: #8c8c8c;
  font-size: 12px;
}

.afu-event-meta {
  color: #6c757d;
  font-size: 12px;
  margin-top: 2px;
}

.afu-event-meta i {
  margin-right: 3px;
}

.afu-event-detail {
  color: #6c757d;
  font-size: 12px;
  margin-top: 4px;
  word-break: break-word;
}

.afu-detail-loading {
  padding: 36px 0;
  text-align: center;
  color: #6c757d;
}

.afu-inline-warning {
  color: #b8860b;
  font-size: 12px;
}

@media (max-width: 1199.98px) {
  .afu-steps-preview-col {
    position: static;
    margin-top: 4px;
  }
}

@media (max-width: 767.98px) {
  .afu-detail-header-actions {
    width: 100%;
    justify-content: flex-start;
    margin-top: 12px;
  }

  .afu-action-bar {
    display: block;
  }

  .afu-action-bar-left {
    min-width: 0;
    margin-bottom: 12px;
  }

  .afu-action-buttons {
    flex: 1 1 auto;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .afu-action-buttons .btn {
    margin-bottom: 4px;
  }

  .afu-stat-icon {
    width: 38px;
    height: 38px;
    flex-basis: 38px;
    font-size: 16px;
  }

  .afu-stat-value {
    font-size: 21px;
  }

  .afu-step-header {
    flex-wrap: wrap;
  }

  .afu-step-header-right {
    width: 100%;
    justify-content: flex-start;
    margin-top: 8px;
  }

  .afu-filter-search,
  .afu-filter-status {
    flex-basis: 100%;
  }

  .afu-filter-buttons {
    width: 100%;
  }

  .afu-filter-buttons .btn {
    flex: 1;
  }
}
</style>

<style>
.afu-history-modal .ant-modal,
.afu-template-save-modal .ant-modal {
  max-width: calc(100vw - 32px);
}

@media (max-width: 575.98px) {
  .afu-history-modal .ant-modal,
  .afu-template-save-modal .ant-modal {
    max-width: calc(100vw - 16px);
    margin: 8px auto;
  }

  .afu-history-modal .ant-modal-body,
  .afu-template-save-modal .ant-modal-body {
    padding: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/autoFollowUp/detail.vue